<template>
  <inline-descriptor
    :ref="'inlineDescriptor' + id"
    :id="id"
    :model-value="computedModel"
    @update:modelValue="onUpdateModelValue"
    :schema="computedSchema"
    :token-styles="computedTokenStyles"
    :bold-selected="boldSelected"
    :separators="separators"
    :update-token="customUpdateToken"
    :is-table="isTable"
    @update-menu="handleUpdateMenu"
    :enable-menu="isRoot"
    :is-root-level="isRoot"
    :createMode="createMode"
    :editable="editable"
    :plain-fields-open-menu="menuForPlainFields"
    :is-vertical="isVertical"
    :context-trigger="contextTrigger"
    :move-to-body="moveToBody"
    @reportWidths="onReportWidths"
    @add-list-item="addListItem"
    @remove-list-item="removeListItem"
    @clear-field="clearFieldValue"
    @add-value="onAddValue"
    @title-action="$emit('title-action', $event)"
    :add-value-field-key="addValueFieldKey"
    :value-request-pending="valueRequestPending"
    :show-field-label="showFieldLabel"
    @blur="closeMenu"
    @keydown.up.exact.prevent="
      () => {
        if ($refs.aux_selector_def) {
          $refs.aux_selector_def.trackArrowUp(1);
        } else if ($refs.aux_selector_custom) {
          $refs.aux_selector_custom.trackArrowUp(1);
        }
      }
    "
    @keydown.down.exact.prevent="
      () => {
        if ($refs.aux_selector_def) {
          $refs.aux_selector_def.trackArrowDown(1);
        } else if ($refs.aux_selector_custom) {
          $refs.aux_selector_custom.trackArrowDown(1);
        }
      }
    "
    @keydown.enter.exact.prevent="onEnter()"
    @keydown.esc.exact.prevent="onEscape()"
  >
    <template #menu-content>
      <div
        class="parameter-inline-menu-row row no-wrap"
        :class="{
          'parameter-inline-menu-row--min-height-when-empty': showBothBlocksEmpty,
          'parameter-inline-menu-row--fit': customHintsInRightColumn,
        }"
      >
        <div
          v-if="
            editable &&
            isRoot &&
            templateId &&
            activeValueType === 4 &&
            templateId !== 999
          "
          class="parameter-inline-menu-col parameter-inline-menu-col--left"
          :class="{ 'parameter-inline-menu-col--left-no-header': !showHintHeaderButton }"
        >
          <div
            class="parameter-inline-menu-col__header parameter-inline-menu-col__header--btn"
            :class="{ 'parameter-inline-menu-col__header--pending': valueRequestPending }"
            v-if="showHintHeaderButton"
            @click="onHintHeaderAdd"
          >
            <span class="parameter-inline-menu-col__header-text">{{ this.sectionText ? $t('add_value')+':' : $t('reset_value') }}&nbsp;{{ this.sectionText }}</span>
          </div>
          <div ref="leftSelectorWrapper" class="parameter-inline-menu-col__selector">
            <aux-selector
              ref="aux_selector_def"
              style="min-width: 300px"
              :filter-model-value="aux_filter_string"
              :input-index="0"
              :show-search-header="false"
              :limit-height-to-container="true"
              :container-height-px="leftSelectorHeightPx"
              :component-model="componentModel"
              :allow-free-input="false"
              :allow-multiple="true"
              :model-type="valueSetFromInstance ? 32 : 21"
              :set-id="templateId"
              :instance-id="instanceId || 0"
              :is-parameter-instance="!isRecordFieldInstance(instanceId || 0)"
              v-model="defhints"
              @hintedSetType="hintedSetTypeFromSelector = $event"
              @hintsLoaded="onDefaultHintsLoaded"
              @selectorClosed="closeMenu"
            />
          </div>
        </div>
        <div
          v-if="showRightHintsColumn"
          v-show="rightSelectorHasData === true"
          class="parameter-inline-menu-col parameter-inline-menu-col--right"
          :class="{ 'parameter-inline-menu-col--right-hints': customHintsInRightColumn }"
        >
          <div
            class="parameter-inline-menu-col__header parameter-inline-menu-col__header--static"
            v-if="!customHintsInRightColumn"
          >
            {{ $t('positions_label') }}:
          </div>
          <div ref="rightSelectorWrapper" class="parameter-inline-menu-col__selector parameter-inline-menu-col__selector--right">
            <aux-selector
              ref="aux_selector_custom"
              class="parameter-inline-menu-col__selector-right"
              style="min-width: 30vw; max-width: 70vw"
              :container-height-px="rightSelectorHeightPx"
            :show-search-header="false"
            :limit-height-to-container="true"
            :filter-model-value="aux_filter_string"
            :allow-free-input="false"
            :allow-multiple="true"
            :component-model="componentModel"
            :model-type="useCustomHints || valueSetFromInstance ? 30 : 20"
            :input-index="0"
            :set-id="templateId"
            :instance-id="valueSetFromInstance ? (instanceId || 0) : 0"
            :is-parameter-instance="!isRecordFieldInstance(instanceId || 0)"
            :instance-custom-hints="valueSetFromInstance"
            v-model="rightSelectorModel"
            @selectedHint="onCustomHintNotes"
            @selectorClosed="closeMenu"
            @dataAvailable="onRightSelectorDataAvailable"
          />
          </div>
        </div>
      </div>
      <teleport to="body">
        <div
          v-if="showNoMatchHint"
          class="parameter-inline-hint-anchor"
          :style="{
            left: noMatchHintRect.x + 'px',
            top: noMatchHintRect.y + 'px',
            width: noMatchHintRect.w + 'px',
          }"
        >
          <q-tooltip
            v-model="showNoMatchHint"
            no-parent-event
            anchor="top middle"
            self="bottom middle"
            :offset="[0, 6]"
            class="parameter-inline-tooltip"
          >
            {{ $t('no_matches') }}
          </q-tooltip>
        </div>
      </teleport>
      <confirm-action-popup
        v-if="addConfirmOpen"
        :title="$t('confirm_action_title')"
        :question="
          $t('confirm_add_value_to_set_question', {
            name: '«' + addConfirmText + '»',
          })
        "
        :position="addConfirmPos"
        :width="addConfirmWidth"
        @confirm="confirmAddValue"
        @cancel="cancelAddValue"
      />
    </template>
  </inline-descriptor>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import { PropType, reactive, Component as vue_c, markRaw } from "vue";
import InlineDescriptor, { SchemaField, Token } from "./InlineDescriptor.vue";
import {
  V2ParameterValueSetExtensionType,
  V2ParameterValueSet_ValueType,
  V2ParameterValueType,
} from "@/models/etc/parameter-types";
import {
  ParameterInstance,
  ParameterInstanceContainer,
  ParameterInstanceContainerFilled,
} from "../../../models/interfaces/parameters/parameter-models";
import {
  ParameterInstanceContainerType,
  V2FieldValueDisplayType,
  V2RecordAxisType,
} from "../../../models/etc/types";
// import AuxSelector from "@/components/common/aux-selector/AuxSelector.vue";
import _, { debounce, first, last } from "lodash";
import { StorageItemSearched } from "../../../models/interfaces/storage/storage-models";
import { date } from "quasar";
import { parameterStore } from "../../../store/parameters/parameter-store";
import {
  isNumeric,
  isNumericFloat,
  createEmptyFromInstance,
  hasInstanceContainerStructureChanged,
  mapFilledContainerFromInstance,
  isInstanceContainerEmpty,
  resetInstanceValue
} from "../../../models/helpers/parameter-helpers";
import { findRecursive } from "../../../models/helpers/recursive";
import ParameterCheckbox from "./ParameterCheckbox.vue";
import { multiEditStore } from "../../../store/multiedit";
import ParameterDateField from "./ParameterDateField.vue";
import ConfirmActionPopup from "@/components/common/basic/confirm/ConfirmActionPopup.vue";
import { CommonEntity } from "../../../models/interfaces/common";

/**
 * A component for displaying Record type
 */

const SPECIAL_TEMPLATE_IDS = new Set([998, 999]);

@Component({
  name: "ParameterInline",
  emits: [
    "update:modelValue",
    "update:nested",
    "add-value",
    "clear-field",
    "storagePosChange",
    "reportWidths",
    "title-action",
  ],
  components: {
    InlineDescriptor,
    ParameterInline,
    ParameterCheckbox: markRaw(ParameterCheckbox),
    ParameterDateField: markRaw(ParameterDateField),
    ConfirmActionPopup,
  },
  expose: [
    "rebuildSchema",
    "clearCurrentPositionMark",
    "releaseFieldFocus",
    "fieldRect",
    "fieldArea",
    "leaveField",
    "eraseFieldMarkup",
    "closeValueSetFieldAsOutside",
  ],
})
export default class ParameterInline extends Vue {
  @Prop({ type: String, required: true }) id!: string;
  @Prop({ type: Array, default: () => [] })
  modelValue!: ParameterInstanceContainer[];
  @Prop({ type: Object, default: () => ({}) }) tokenStyles!: Record<
    string,
    string
  >;
  @Prop({ type: String, default: "" }) indexPrefix!: string;
  @Prop({ type: Boolean, default: false }) editable!: boolean;
  @Prop({ type: Boolean, default: false }) isTable?: boolean;
  @Prop({ type: Boolean, default: false }) isRoot!: boolean;
  @Prop({ type: Boolean, default: true }) showFieldLabel!: boolean;
  @Prop({ type: Boolean, default: false }) moveToBody?: boolean;
  @Prop({ type: Boolean, default: true }) showCustom!: boolean;
  @Prop({ type: Boolean, default: false }) useVendorCode!: boolean;
  @Prop({ type: Boolean, default: false }) useStorageField!: boolean;
  @Prop({ type: Boolean, default: false }) isVertical!: boolean;
  @Prop({ type: Boolean, default: true }) createMode!: boolean;
  @Prop({ type: Boolean, default: false }) maintainStringValue!: boolean;
  @Prop({ type: Number, default: 0 }) storageForHint!: number;
  @Prop({ type: Boolean, default: false }) useCustomHints!: boolean;
  @Prop({ type: Boolean, default: false }) boldSelected!: boolean;
  // вне склада левая колонка грузит подсказки вхождения или поля, а не набор склада
  @Prop({ type: Boolean, default: false }) valueSetFromInstance!: boolean;
  // прокидывается InlineDescriptor в вложенно отрисованные компоненты; здесь не используется,
  // объявлен чтобы не падал в DOM-атрибуты при рендере вложенного ParameterInline в списке
  @Prop({ default: undefined }) nestedIndex?: number;
  // приходит от корневого экземпляра во вложенные; у корня пропа нет, он считает признак сам.
  // Без type: Boolean, иначе Vue приведёт отсутствующее значение к false и корень потеряет свой расчёт
  @Prop({ default: undefined }) plainFieldsOpenMenu?: boolean;

  @Prop({ type: Object as PropType<HTMLElement | null> })
  contextTrigger?: PropType<HTMLElement | null> = undefined;

  // Внутри класса компонента
  debouncedFilterUpdate!: any;

  // temporary
  positions: any[] = [];
  defhints: any[] = [];
  customHintsModel: any[] = [];
  customHintNotes: [number, { Id: number; Name: string }][] = [];

  // Кастомная подсказка к/п и склада пишет выбранное значение в одну модель.
  // Колонка позиций склада остаётся отдельно: у позиции другой состав.
  get rightSelectorModel(): any[] {
    return this.useCustomHints || this.valueSetFromInstance
      ? this.customHintsModel
      : this.positions;
  }
  set rightSelectorModel(val: any[]) {
    if (this.useCustomHints || this.valueSetFromInstance) {
      this.customHintsModel = val;
    } else {
      this.positions = val;
    }
  }
  aux_filter_string: string = "";
  componentModel: {
    vendorCode: string;
    container: ParameterInstanceContainerFilled | null;
    isEmpty: boolean;
    storageForFilter?: number | null;
    possibleValueSetsIds?: number[];
  } = { vendorCode: "", isEmpty: true, container: null };

  parameter_store: any | undefined = undefined;
  multiedit_store: any | undefined = undefined;

  fieldKey: string | null = null;
  sectionText: string = "";
  // Поле под правкой: снимается на blur и ставится любым другим событием поля.
  // Ключ поля после blur остаётся, поэтому принадлежности правке по нему не видно.
  fieldEditing: boolean = false;
  // templateId of the current selected cell, it can change with focus
  templateId: number | undefined = undefined;
  activeNestedIndex: number | undefined = undefined;
  // templateId of the current selected cell, it can change with focus
  instanceId: number | undefined = undefined;
  activeValueType: number | undefined = undefined;

  /** HintedSetType от AuxSelector после загрузки Hints (undefined = ещё не пришли, null/число = пришли) */
  hintedSetTypeFromSelector: number | null | undefined = undefined;

  // Первая страница подсказок по умолчанию: текст запроса и было ли в выдаче точное
  // совпадение. Текст хранится, потому что ответ мог прийти на уже устаревший текст поля.
  defaultHintsLoaded: { filter: string; exactMatch: boolean } | null = null;

  // Текст, значение с которым только что добавлено в набор. Держим отдельно от выдачи
  // подсказок: она про этот текст ещё не перезапрашивалась, а значение в наборе уже есть.
  createdInSetText: string | null = null;

  // Набор, который расширяется только с подтверждением: перед созданием значения
  // спрашиваем пользователя, а текст и место диалога фиксируем на момент вопроса
  addConfirmOpen = false;
  addConfirmText = "";
  addConfirmPos: { x: number; y: number } = { x: 0, y: 0 };
  readonly addConfirmWidth = 240;

  // Короткое сообщение над ячейкой: Enter по закрытому набору, в котором набранного
  // значения нет, и добавить его туда нельзя. Прямоугольник ячейки снимается в момент
  // показа и служит якорем, потому что сама секция живёт в дескрипторе.
  showNoMatchHint = false;
  noMatchHintRect: { x: number; y: number; w: number } = { x: 0, y: 0, w: 0 };
  private noMatchHintTimer: ReturnType<typeof setTimeout> | undefined = undefined;

  readonly V2ParameterValueSetExtensionType = V2ParameterValueSetExtensionType;

  /** Высота левого блока подсказки (для передачи в aux-selector), чтобы «все данные загружены» влезало */
  leftSelectorHeightPx: number = 0;
  /** Высота правого блока подсказки (для передачи в aux-selector), чтобы по высоте был стабилен */
  rightSelectorHeightPx: number = 0;
  /** null = ещё не загружено (показываем оптимистично), false = пусто, true = есть данные */
  rightSelectorHasData: boolean | null = null;
  private leftResizeObserver: ResizeObserver | null = null;
  private rightResizeObserver: ResizeObserver | null = null;

  /**
   * Режим поиска позиций, в котором меню открывается и для простых полей, а не только
   * для ValueSet (тот же предикат, что и при вызове openMenu ниже). Корню проп не приходит,
   * поэтому он считает признак по своим showCustom и useCustomHints, а вложенные берут
   * готовое значение корня, потому что меню открывает только корневой экземпляр.
   */
  get menuForPlainFields(): boolean {
    return this.plainFieldsOpenMenu ?? (this.showCustom && !this.useCustomHints);
  }

  // Галка у заметки подсказки показывается только для смежных одиночных полей того
  // уровня записи, где стоит активное поле, и без набора самого поля. Подстановка
  // умеет больше, см. findInstanceByValueSetId: там и списки, и вложенные записи.
  get possibleValueSetsIds(): number[] {
    if (!this.useCustomHints && !this.valueSetFromInstance) return [];
    const fields = this.hintSourceRecordFields();
    if (!fields) return [];
    const ownSetId = this.hintSourceValueSetId(fields);
    const ids: number[] = [];
    for (const p of fields) {
      if (p.Type !== ParameterInstanceContainerType.SingleInstance) continue;
      const inst = p.Instance;
      if (!inst || inst.ValueType !== V2ParameterValueType.ValueSet) continue;
      if (inst.ValueSet?.Id == null || inst.ValueSet.Id === ownSetId) continue;
      ids.push(inst.ValueSet.Id);
    }
    return [...new Set(ids)];
  }

  // Наборы по всей модели, вместе с элементами списков и вложенными записями.
  // Держим отдельно от possibleValueSetsIds: если галку понадобится показывать
  // так же широко, как работает подстановка, признак берётся отсюда.
  get allValueSetsIds(): number[] {
    if (!this.useCustomHints && !this.valueSetFromInstance) return [];
    const ids: number[] = [];
    const visitInst = (inst: ParameterInstance | null | undefined) => {
      if (!inst) return;
      if (
        inst.ValueSet?.Id != null &&
        inst.ValueType === V2ParameterValueType.ValueSet &&
        inst.TemplateId !== this.templateId
      ) {
        ids.push(inst.ValueSet.Id);
      }
      if (inst.RecordFields?.length) visit(inst.RecordFields);
    };
    const visit = (fields: ParameterInstanceContainer[]) => {
      for (const p of fields) {
        visitInst(p.Instance);
        p.ListTitle?.Instances?.forEach(visitInst);
      }
    };
    visit(this.parameters);
    return [...new Set(ids)];
  }

  // Кнопка добавления живёт на том же условии, что значок в поле: в таблице нужна
  // пришедшая выдача ровно под текущий текст и отсутствие в ней такого же значения.
  // Пустой текст это сброс значения, выдача для него ни при чём.
  get showHintHeaderButton(): boolean {
    return (
      this.templateId !== 998 &&
      this.hintedSetTypeFromSelector !== undefined &&
      (!this.sectionText ||
        (this.hintedSetTypeFromSelector !==
          V2ParameterValueSetExtensionType.Closed &&
          (!this.isTable || this.hintsAnswerForSectionText) &&
          !this.exactHintForSectionText))
    );
  }

  onDefaultHintsLoaded(payload: { filter: string; exactMatch: boolean }) {
    this.defaultHintsLoaded = payload;
  }

  // Загруженная выдача относится ровно к тому тексту, что сейчас в поле. Фильтр уходит в
  // селектор с задержкой, и пока он догоняет, прежний ответ говорит о другом тексте.
  get hintsAnswerForSectionText(): boolean {
    const loaded = this.defaultHintsLoaded;
    if (!loaded) return false;
    return (
      loaded.filter.trim().toLowerCase() ===
      (this.sectionText || "").trim().toLowerCase()
    );
  }

  // Значение с таким именем в наборе уже есть, добавлять нечего. Признак только для таблицы
  get exactHintForSectionText(): boolean {
    if (!this.isTable) return false;
    const text = (this.sectionText || "").trim().toLowerCase();
    if (
      text &&
      this.createdInSetText &&
      this.createdInSetText.trim().toLowerCase() === text
    ) {
      return true;
    }
    return this.hintsAnswerForSectionText && !!this.defaultHintsLoaded?.exactMatch;
  }

  // В правом столбце либо таблица кастомных подсказок, либо список позиций. У таблицы
  // свои заголовки столбцов, поэтому надпись над ней не нужна, и ширину она берёт по
  // меню, а не по контенту. У позиций раскладка остаётся прежней.
  get customHintsInRightColumn(): boolean {
    return this.useCustomHints || this.valueSetFromInstance;
  }

  get showRightHintsColumn(): boolean {
    if (!this.editable || !this.isRoot || !this.templateId || this.templateId === 998) {
      return false;
    }
    if (this.valueSetFromInstance) {
      return (
        this.activeValueType === V2ParameterValueType.ValueSet &&
        this.templateId !== 999
      );
    }
    return this.useCustomHints ? this.templateId !== 999 : this.showCustom;
  }

  @Watch("showHintHeaderButton")
  onHintHeaderChange() {
    if (
      this.isRoot &&
      this.templateId &&
      this.templateId !== 999 &&
      this.activeValueType === V2ParameterValueType.ValueSet
    ) {
      this.measureLeftSelectorHeight();
    }
  }

  /** Оба столбца видимы и оба без данных — min-height только в этой подсказке; один блок или есть данные — контент определяет высоту. */
  get showBothBlocksEmpty(): boolean {
    if (!this.editable || !this.isRoot || !this.templateId || this.templateId === 998 || this.templateId === 999) return false;
    if (this.activeValueType !== 4) return false;
    if (!this.showRightHintsColumn && !this.showCustom && !this.useCustomHints) return false;
    if ((this.defhints?.length ?? 0) > 0 || (this.positions?.length ?? 0) > 0) return false;
    return true;
  }

  get computedTokenStyles(): Record<string, string> {
    if (!this.boldSelected) return this.tokenStyles;
    const result: Record<string, string> = { ...this.tokenStyles };
    const prefix = this.indexPrefix;
    for (const param of this.parameters) {
      const ttl = param.ListTitle;
      const insts = param.Instance;
      if (param.Type === ParameterInstanceContainerType.List && ttl) {
        const templateId = ttl.Instances[0]?.TemplateId;
        ttl.Instances.forEach((item, i) => {
          if (item.SelectedValue?.Id > 0) {
            const key = `param_${templateId}_${prefix}${i}`;
            result[key] = (result[key] ? result[key] + '; ' : '') + 'font-weight: 500';
          }
        });
      } else if (insts) {
        if (insts.SelectedValue?.Id > 0) {
          const key = `param_${insts.TemplateId}_${prefix}`;
          result[key] = (result[key] ? result[key] + '; ' : '') + 'font-weight: 500';
        }
      }
    }
    return result;
  }

  computedSchema: SchemaField[] = reactive([]);

  // Структура, из которой построена текущая схема. Нужна как база сравнения: живой
  // this.parameters к моменту проверки может быть уже синхронен пришедшей модели, и тогда
  // изменение становится невидимым, а схема остаётся от прежней структуры
  private schemaSource: ParameterInstanceContainer[] = [];

  private schemaRebuildScheduled = false;
  computedModel: Record<string, any> = reactive({});
  componentStorageValue: any = null;

  // in storage items mode this is the currently selected one
  currentStoragePos: any = {
    currentPosId: 0,
    currentPosPrice: 0,
    currentPosPriceType: 0,
    currentPosUnit: 0,
    currentPosStorages: [],
  };

  // table column widths
  pending: { templateId: string; width: number }[] = [];
  // scheduled = false;
  stableTimer: any = null;
  selectedValueCache: any = null;

  private separators = [","];
  parameters = reactive<ParameterInstanceContainer[]>(
    Array.isArray(this.modelValue) ? this.modelValue : []
  );

  private getMainParam(): ParameterInstanceContainer | undefined {
    const idx = this.useVendorCode ? 1 : 0;
    const param = this.parameters[idx];
    if (!param) return undefined;
    const tid = param.Instance?.TemplateId;
    if (tid != null && SPECIAL_TEMPLATE_IDS.has(tid)) return undefined;
    return param;
  }

  created() {
    this.parameter_store = parameterStore();
    this.multiedit_store = multiEditStore();
  }

  mounted() {
    this.parameters = reactive<ParameterInstanceContainer[]>(
      Array.isArray(this.modelValue) ? this.modelValue : []
    );
    this.rebuildSchema();
    this.computedModel = reactive(
      this.createModelValue(this.parameters, this.indexPrefix)
    );
    if (this.isRoot) {
      const mainParam = this.getMainParam();
      const cont = mainParam
        ? mapFilledContainerFromInstance([_.cloneDeep(mainParam)], true)[0]
        : null;
      this.componentModel = reactive({
        vendorCode: this.parameters[0]?.Instance?.StringValue || "",
        container: cont,
        isEmpty: mainParam ? isInstanceContainerEmpty(mainParam) : true,
        storageForFilter: this.useStorageField ? this.componentStorageValue?.Id : this.storageForHint,
        possibleValueSetsIds: this.useCustomHints || this.valueSetFromInstance ? this.possibleValueSetsIds : undefined,
      });
    }

    this.debouncedFilterUpdate = debounce(() => this.applyFilterUpdate(), 300);
  }

  /** Нормализация контейнера для сравнения: только TemplateId, StringValue, ValueOfSet, RecordFields (mapFilledContainerFromInstance не выдаёт NumberValue/BoolValue/DateValue). */
  private normalizeContainerForFilterCompare(c: ParameterInstanceContainerFilled | null | undefined): ParameterInstanceContainerFilled | null {
    if (c == null) return null;
    const recordFields = (c.RecordFields || [])
      .map((f) => this.normalizeContainerForFilterCompare(f))
      .filter((x): x is ParameterInstanceContainerFilled => x != null);
    return {
      TemplateId: c.TemplateId,
      StringValue: c.StringValue,
      ValueOfSet: c.ValueOfSet,
      RecordFields: recordFields,
    };
  }

  /** Обновление фильтра (aux_filter_string, componentModel). При смене секции вызываем напрямую, чтобы не давать второй вызов через debounce. */
  applyFilterUpdate() {
    if (!this.isRoot) { return }
    if (this.aux_filter_string != this.sectionText) {
      this.aux_filter_string = this.sectionText;
      if (this.componentModel && this.templateId === 999) {
        this.componentModel.vendorCode = this.sectionText;
      }
    }

    const cont = this.componentModel.container
    const mainParam = this.getMainParam();
    const cont_new = mainParam
      ? mapFilledContainerFromInstance([_.cloneDeep(mainParam)], true)[0]
      : null;

    if (
      this.componentModel.vendorCode !=
        (this.parameters[0]?.Instance?.StringValue || "") ||
      !_.isEqual(cont, cont_new) ||
      this.componentModel.storageForFilter != (this.useStorageField ? this.componentStorageValue?.Id : this.storageForHint)
      ) {
        this.componentModel = reactive({
        vendorCode: this.parameters[0]?.Instance?.StringValue || "",
        container: cont_new,
        isEmpty: mainParam ? isInstanceContainerEmpty(mainParam) : true,
        storageForFilter: this.useStorageField ? this.componentStorageValue?.Id : this.storageForHint,
        possibleValueSetsIds: this.useCustomHints || this.valueSetFromInstance ? this.possibleValueSetsIds : undefined,
      });
    }
  }

  onReportWidths(widthArray: any[]) {
    if (this.isRoot && this.editable) {
      // this.pending.push(...widthArray);

      // if (!this.scheduled) {
      //   this.scheduled = true;
      //   requestAnimationFrame(this.commitWidths);
      // }

      this.pending.push(...widthArray);
      // Сбрасываем прошлый таймер
      clearTimeout(this.stableTimer);
      // Запускаем новый — “ждём пока всё утихнет”
      // this.stableTimer = setTimeout(() => this.commitWidths(), 500);
    } else {
      this.$emit("reportWidths", widthArray);
    }
  }

  // Схема не опустошается перед сборкой. Пустая схема это отдельное срабатывание вотчера
  // в inline-descriptor, то есть лишний проход и кадр с пустой разметкой, от которого
  // уезжает прокрутка в прокручиваемом предке.
  //
  // Повторные вызовы в одном такте не копятся. Внешняя смена модели идёт несколькими
  // правками подряд, каждая будит вотчер, и вдобавок снаружи зовут этот метод руками.
  // Сборка схемы на большом дереве дорогая, а каждое присваивание это ещё и проход
  // в inline-descriptor, поэтому хватает одной сборки по итоговой модели
  rebuildSchema() {
    if (this.schemaRebuildScheduled) {
      return;
    }
    this.schemaRebuildScheduled = true;

    const that = this;
    this.$nextTick(() => {
      that.schemaRebuildScheduled = false;
      that.computedSchema = reactive(
        that.createSchema(that.parameters, that.indexPrefix)
      );
      that.schemaSource = _.cloneDeep(that.parameters);
    });
  }

  commitWidths() {
    if (!this.editable) {
      return;
    }
    const maxByTemplate = new Map<string, number>();

    for (const { templateId, width } of this.pending) {
      const prev = maxByTemplate.get(templateId) || 0;
      if (width > prev) maxByTemplate.set(templateId, width);
    }

    this.pending.length = 0;
    // this.scheduled = false;

    const inlineDescriptor = this.$refs["inlineDescriptor" + this.id] as any;
    if (inlineDescriptor) {
      // Ищем все td внутри компонента
      const tds = inlineDescriptor.$el.querySelectorAll("td[data-template-id]");
      tds.forEach((td: any) => {
        const templateId = td.getAttribute("data-template-id")!;
        (td as HTMLElement).style.width = `var(--w-${templateId})`;
        (td as HTMLElement).style.minWidth = `var(--w-${templateId})`;
        (td as HTMLElement).style.maxWidth = `var(--w-${templateId})`;
      });
    }

    // Записываем CSS custom props
    const root = document.documentElement;
    for (const [templateId, width] of maxByTemplate.entries()) {
      root.style.setProperty(`--w-${templateId}`, `${width}px`);
    }
  }

  @Watch("modelValue", { deep: true })
  onModelValueChange(newValue: ParameterInstanceContainer[]) {
    if (!this.debouncedFilterUpdate || !this.modelValue) { return }

    const structureChanged = hasInstanceContainerStructureChanged(
      this.schemaSource,
      newValue
    );

    this.parameters.splice(
      0,
      this.parameters.length,
      ...reactive<ParameterInstanceContainer[]>(
        Array.isArray(newValue) ? newValue : []
      )
    );

    this.computedModel = reactive(
      this.createModelValue(this.parameters, this.indexPrefix)
    );

    // Схему перестраивает тот уровень, до которого дошла новая модель, а не только
    // корневой. Сверка в inline-descriptor сохраняет узлы, значит вложенный уровень
    // больше не пересоздаётся сверху и свою схему должен обновить сам.
    //
    // Раньше, чем изменение дойдёт до корня, это не случится: наверх уходит событие,
    // а своя модель меняется только когда пропом вернётся обработанная. Сравнение идёт
    // со структурой, из которой построена текущая схема, поэтому уровень берётся за
    // работу лишь тогда, когда у него самого правда изменилась структура
    if (!this.computedSchema.length || structureChanged) {
      this.rebuildSchema();
    }

    if (this.useStorageField && this.parameters && this.parameters.length) {
      const last_cell = this.parameters[this.parameters.length-1];
      if (last_cell.Type === ParameterInstanceContainerType.SingleInstance && last_cell.Instance?.TemplateId === 998) {
        this.componentStorageValue = last_cell.Instance?.SelectedValue;
      }
    }

    if (this.isRoot) {
      const mainParam = this.getMainParam();
      const cont_new = mainParam
        ? mapFilledContainerFromInstance([_.cloneDeep(mainParam)], true)[0]
        : null;
      const vendorCode = this.parameters[0]?.Instance?.StringValue || "";
      const storageForFilter = this.useStorageField ? this.componentStorageValue?.Id : this.storageForHint;
      const eqStr = this.aux_filter_string === this.sectionText;
      const eqVendor = this.componentModel.vendorCode === vendorCode;
      const eqCont = _.isEqual(this.componentModel.container, cont_new);
      const eqContNormalized = _.isEqual(
        this.normalizeContainerForFilterCompare(this.componentModel.container),
        this.normalizeContainerForFilterCompare(cont_new)
      );
      const eqStorage = this.componentModel.storageForFilter === storageForFilter;
      const filterUnchanged = eqStr && eqVendor && (eqCont || eqContNormalized) && eqStorage;
      if (!filterUnchanged) {
        this.$nextTick(() => {
          this.debouncedFilterUpdate();
          this.defhints.splice(0);
          this.positions.splice(0);
        });
      }
    }
  }

  @Watch("customHintsModel")
  customHintsModel_watcher() {
    if (!this.customHintsModel.length) return;
    this.defhints = [...this.customHintsModel];
    this.customHintsModel.splice(0);
  }

  onCustomHintNotes(notes: [number, { Id: number; Name: string }][]) {
    this.customHintNotes = notes;
  }

  onRightSelectorDataAvailable(hasData: boolean) {
    this.rightSelectorHasData = hasData;
  }

  @Watch("positions")
  positions_watcher() {
    if (!this.positions.length) {
      return;
    }
    const res = (this.positions[0] as StorageItemSearched).NameParameters;
    let newParameters = _.cloneDeep(this.parameters);

    const params_arr = [...res]

    if (this.useVendorCode) {
      const vcode_cell = {
        Type: ParameterInstanceContainerType.SingleInstance,
        Instance: {
          TemplateId: 999,
          Unremovable: true,
          ValueType: V2ParameterValueType.String,
          StringValue: (this.positions[0] as StorageItemSearched).VendorCode,
          NumberValue: null,
          DateValue: null,
          BoolValue: null,
          ValueSet: null,
          SelectedValue: null,
          ValueDisplayType: V2FieldValueDisplayType.Inline,
          Name: this.$t('sku'),
          Id: 0,
          Round: 2,
          RecordAxisType: V2RecordAxisType.Horizontal,
          RecordFields: [],
        } as ParameterInstance,
        ListTitle: null,
      } as ParameterInstanceContainer;
      params_arr.splice(0, 0, vcode_cell);
    }

    if (this.useStorageField) {
      const storage_cell = {
        Type: ParameterInstanceContainerType.SingleInstance,
        Instance: {
          TemplateId: 998,
          Unremovable: true,
          ValueType: V2ParameterValueType.ValueSet,
          StringValue: '',
          NumberValue: null,
          DateValue: null,
          BoolValue: null,
          ValueSet: {
            Id: 998,
            Name: this.$t('warehouse'),
            StringName: '',
            ValueType: V2ParameterValueSet_ValueType.String
          },
          SelectedValue: this.componentStorageValue,
          ValueDisplayType: V2FieldValueDisplayType.Inline,
          Name: this.$t('warehouse'),
          Id: 0,
          Round: 2,
          RecordAxisType: V2RecordAxisType.Horizontal,
          RecordFields: [],
        } as ParameterInstance,
        ListTitle: null,
      } as ParameterInstanceContainer;
      params_arr.push(storage_cell);
    }
    newParameters = reactive(params_arr);

    this.currentStoragePos = {
      currentPosId: (this.positions[0] as StorageItemSearched).Id,
      currentPosPrice: (this.positions[0] as StorageItemSearched).Price,
      currentPosPriceType: (this.positions[0] as StorageItemSearched).PriceType,
      currentPosUnit: (this.positions[0] as StorageItemSearched).MeasureUnit.Id,
      currentPosStorages: (this.positions[0] as StorageItemSearched)
        .QuantitiesInStock,
    };
    this.unsetWidths();

    this.$emit("storagePosChange", this.currentStoragePos);
    this.$emit("update:modelValue", newParameters); // this.parameters
    this.positions.splice(0);
    this.closeMenu();
    this.releaseFieldFocus();
  }

  // tid и id по умолчанию берутся у активного поля. Явные значения нужны там, где
  // действие приходит не от активного поля, например по значку очистки в чужой ячейке.
  currentTemplateParam(
    model: ParameterInstanceContainer[],
    tid: number | undefined = this.templateId,
    id: number | undefined = this.instanceId
  ): ParameterInstanceContainer {
    if (this.isRoot) {
      // console.log('look for TemplateParam by:');
      // console.log({ tid: this.templateId, id: this.instanceId });
    }
    return findRecursive(
      function a(
        element: ParameterInstanceContainer,
        el_to_find: any
      ): any | undefined {
        if (!element) return undefined;
        if (
          element.Type === ParameterInstanceContainerType.SingleInstance &&
          element.Instance
        ) {
          if (
            el_to_find.tid == element.Instance?.TemplateId &&
            el_to_find.id == element.Instance?.Id
          ) {
            return element;
          }
          if (element.Instance.ValueType === V2ParameterValueType.Record) {
            const found_el = findRecursive(
              a,
              el_to_find,
              element.Instance.RecordFields
            );
            if (found_el) {
              return found_el;
            }
          }
        } else if (
          element.Type === ParameterInstanceContainerType.List &&
          element.ListTitle
        ) {
          for (let pi = 0; pi < element.ListTitle.Instances.length; pi++) {
            const el = element.ListTitle.Instances[pi];
            if (!el) return undefined;

            if (el_to_find.tid == el.TemplateId && el_to_find.id == el.Id) {
              return element;
            }
            if (el.ValueType === V2ParameterValueType.Record) {
              const found_el = findRecursive(a, el_to_find, el.RecordFields);
              if (found_el) {
                return found_el;
              }
            }
          }
        }

        return undefined;
      },
      { tid, id },
      model
    );
  }

  /**
   * Очистка значения по значку в поле.
   *
   * Отдельный канал, а не новое значение eventKind у update-menu: там есть ветки вида
   * «всё, что не 0 и не 1», в которые новое значение провалилось бы и открыло меню,
   * в том числе у стороннего слушателя этого же события.
   *
   * Правка идёт по месту в this.parameters, а не по клону: clearCurrentPositionMark
   * ниже сам клонирует this.parameters и эмитит результат, и на клоне очистка
   * откатилась бы обратно.
   */
  clearFieldValue(payload: {
    fieldKey: string;
    nestedIndex: string | undefined;
    opts: any | undefined;
  }) {
    // Очистку делает корень, потому что у него и модель целиком, и кэш набора значений,
    // и подсказка. Вложенный уровень только поднимает событие, тогда значение, кэш и
    // подсказка меняются в одном месте, а запрос уходит один. Вхождение корень находит
    // по TemplateId и InstanceId из значка, обходя и поля записей.
    if (!this.isRoot) {
      this.$emit("clear-field", payload);
      return;
    }

    const tid = payload.opts?.TemplateId;
    const id = payload.opts?.InstanceId;
    if (tid === undefined || id === undefined) {
      return;
    }

    const templateParam = this.currentTemplateParam(this.parameters, tid, id);
    if (!templateParam) {
      return;
    }

    const nested =
      payload.nestedIndex !== undefined ? Number(payload.nestedIndex) : undefined;
    const inst =
      templateParam.Type === ParameterInstanceContainerType.List &&
      templateParam.ListTitle &&
      nested !== undefined
        ? templateParam.ListTitle.Instances[nested]
        : templateParam.Instance;

    if (!inst) {
      return;
    }

    resetInstanceValue(inst);
    this.eraseFieldMarkup(payload.fieldKey);
    this.selectedValueCache = null;
    // Предложение добавить значение держится на набранном тексте. После сброса в поле
    // текста нет, и добавлять нечего.
    this.sectionText = "";

    this.$emit("update:modelValue", reactive(_.cloneDeep(this.parameters)));
    this.clearCurrentPositionMark(true);

    // Запрос адресует вхождение из opts значка: это поле, которое нарисовано.
    // Тело берётся из модели только когда сброшенное вхождение и есть это поле.
    // Иначе поиск разрешил другое вхождение, и тело собирается пустым по ValueType
    // из opts, тем же составом, что getEditRequest даёт после сброса.
    // В режиме создания запрос не уйдёт: editFieldValueRequest выходит по createMode.
    if (id > 0) {
      const body =
        inst.Id === id
          ? this.getEditRequest(inst)
          : this.emptyClearedRequest(payload.opts?.ValueType, payload.opts?.ValueSet);
      this.editFieldValueRequest(id, body);
    }

    // Очистка уводит из поля. Значение уже сброшено и отправлено, держать в нём каретку
    // и открытую подсказку нечему. Поле записи закрывается так же, каретку в нём держит
    // вложенный описатель, и releaseFieldFocus доходит до него обходом детей.
    if (this.isTable) {
      this.closeMenu();
      this.releaseFieldFocus();
    }
  }

  // Пустое тело для очистки, когда в модели нет сброшенного вхождения с нужным Id.
  // Пустота каждого типа живёт в createEmptyFromInstance, форма тела в getEditRequest.
  private emptyClearedRequest(valueType: number, valueSet: any) {
    const cleared = createEmptyFromInstance(
      {
        ValueType: valueType,
        ValueSet: valueSet,
      } as ParameterInstance,
      0
    );
    return this.getEditRequest(cleared);
  }

  /**
   * Ключ поля, которому сейчас доступно добавление значения в набор. Условия те же, что
   * у кнопки в подсказке: открытое множество, тип ValueSet, непустой введённый текст и
   * в таблице отсутствие такого же значения в загруженной выдаче подсказок. Плюс к ним
   * идущая правка поля: значок стоит в самом поле и живёт только пока его правят.
   */
  get addValueFieldKey(): string | undefined {
    if (!this.isRoot || !this.editable || !this.fieldKey) return undefined;
    // Значок принадлежит идущей правке поля. На уходе из поля значение возвращается
    // из кэша, и набранный текст, на котором держалось предложение, перестаёт быть
    // текстом поля.
    if (!this.fieldEditing) return undefined;
    if (!this.templateId || this.templateId === 999 || this.templateId === 998) {
      return undefined;
    }
    if (this.activeValueType !== V2ParameterValueType.ValueSet) return undefined;
    if (this.hintedSetTypeFromSelector === undefined) return undefined;
    if (
      this.hintedSetTypeFromSelector ===
      V2ParameterValueSetExtensionType.Closed
    ) {
      return undefined;
    }
    if (!this.sectionText) return undefined;
    // В таблице значок живёт только на пришедшей выдаче ровно под текущий текст. Пока
    // ответа нет, неизвестно, есть ли такое значение в наборе, и предлагать добавление нельзя.
    if (this.isTable && !this.hintsAnswerForSectionText) return undefined;
    if (this.exactHintForSectionText) return undefined;

    return this.fieldKey;
  }

  // Поля строки, в которую пишутся галки. Первая по пути к активному полю
  // горизонтальная запись, которая сама элемент списка. Если такой нет,
  // первая запись на этом пути: для склада это корневая запись.
  private hintRowFields(model: ParameterInstanceContainer[]): ParameterInstanceContainer[] | null {
    const trail: ParameterInstanceContainer[][] = [];
    const horizontal: ParameterInstanceContainer[][] = [];
    if (!this.collectHintRow(model, trail, horizontal)) {
      return null;
    }
    if (horizontal.length) return horizontal[0];
    return trail.length ? trail[0] : null;
  }

  private collectHintRow(
    containers: ParameterInstanceContainer[],
    trail: ParameterInstanceContainer[][],
    horizontal: ParameterInstanceContainer[][]
  ): boolean {
    for (const p of containers) {
      if (p.Type === ParameterInstanceContainerType.SingleInstance && p.Instance) {
        if (this.isHintSourceField(p.Instance)) return true;
        if (p.Instance.ValueType === V2ParameterValueType.Record && p.Instance.RecordFields?.length) {
          if (this.descendHintRecord(p.Instance, false, trail, horizontal)) return true;
        }
      } else if (p.Type === ParameterInstanceContainerType.List && p.ListTitle) {
        for (const inst of p.ListTitle.Instances) {
          if (!inst) continue;
          if (inst.ValueType === V2ParameterValueType.Record && inst.RecordFields?.length) {
            if (this.descendHintRecord(inst, true, trail, horizontal)) return true;
          } else if (this.isHintSourceField(inst)) {
            return true;
          }
        }
      }
    }
    return false;
  }

  // Запись остаётся на пути, только если активное поле внутри неё или это оно само.
  private descendHintRecord(
    inst: ParameterInstance,
    listItem: boolean,
    trail: ParameterInstanceContainer[][],
    horizontal: ParameterInstanceContainer[][]
  ): boolean {
    const fields = inst.RecordFields;
    const isRow = listItem && inst.RecordAxisType === V2RecordAxisType.Horizontal;
    trail.push(fields);
    if (isRow) horizontal.push(fields);
    if (this.isHintSourceField(inst) || this.collectHintRow(fields, trail, horizontal)) {
      return true;
    }
    trail.pop();
    if (isRow) horizontal.pop();
    return false;
  }

  private isHintSourceField(inst: ParameterInstance): boolean {
    return this.templateId !== undefined
      && this.instanceId !== undefined
      && inst.TemplateId === this.templateId
      && inst.Id === this.instanceId;
  }

  // Активное поле лежит в одном элементе списка: галки подсказки ищем только в нём.
  private hintListScope(instances: (ParameterInstance | null | undefined)[]): ParameterInstance[] {
    const onPath = instances.find((inst) => {
      if (!inst) return false;
      if (this.isHintSourceField(inst)) return true;
      return (
        inst.ValueType === V2ParameterValueType.Record &&
        !!inst.RecordFields?.length &&
        this.hintSourceInFields(inst.RecordFields)
      );
    });
    if (onPath) return [onPath];
    return instances.filter((inst): inst is ParameterInstance => !!inst);
  }

  private hintSourceInFields(containers: ParameterInstanceContainer[]): boolean {
    for (const p of containers) {
      if (p.Type === ParameterInstanceContainerType.SingleInstance && p.Instance) {
        if (this.isHintSourceField(p.Instance)) return true;
        if (
          p.Instance.ValueType === V2ParameterValueType.Record &&
          p.Instance.RecordFields?.length &&
          this.hintSourceInFields(p.Instance.RecordFields)
        ) {
          return true;
        }
      } else if (p.Type === ParameterInstanceContainerType.List && p.ListTitle) {
        for (const inst of p.ListTitle.Instances) {
          if (!inst) continue;
          if (this.isHintSourceField(inst)) return true;
          if (
            inst.ValueType === V2ParameterValueType.Record &&
            inst.RecordFields?.length &&
            this.hintSourceInFields(inst.RecordFields)
          ) {
            return true;
          }
        }
      }
    }
    return false;
  }

  // Уровень записи, в котором лежит активное поле: ближняя запись на пути, а не строка
  // целиком. Поле верхнего уровня записи над собой не имеет, тогда смежных полей нет.
  private hintSourceRecordFields(): ParameterInstanceContainer[] | null {
    const trail: ParameterInstanceContainer[][] = [];
    const horizontal: ParameterInstanceContainer[][] = [];
    if (!this.collectHintRow(this.parameters, trail, horizontal)) {
      return null;
    }
    return trail.length ? trail[trail.length - 1] : null;
  }

  private hintSourceValueSetId(fields: ParameterInstanceContainer[]): number | undefined {
    for (const p of fields) {
      if (p.Instance && this.isHintSourceField(p.Instance)) {
        return p.Instance.ValueSet?.Id ?? undefined;
      }
      const inList = p.ListTitle?.Instances?.find(
        (inst) => !!inst && this.isHintSourceField(inst)
      );
      if (inList) return inList.ValueSet?.Id ?? undefined;
    }
    return undefined;
  }

  private findInstanceByValueSetId(containers: ParameterInstanceContainer[], valueSetId: number): ParameterInstance | null {
    for (const p of containers) {
      if (p.Type === ParameterInstanceContainerType.SingleInstance && p.Instance) {
        if (
          p.Instance.ValueSet?.Id === valueSetId
          && p.Instance.ValueType === V2ParameterValueType.ValueSet
          && !this.isHintSourceField(p.Instance)
        ) {
          return p.Instance;
        }
        if (p.Instance.ValueType === V2ParameterValueType.Record && p.Instance.RecordFields?.length) {
          const found = this.findInstanceByValueSetId(p.Instance.RecordFields, valueSetId);
          if (found) return found;
        }
      } else if (p.Type === ParameterInstanceContainerType.List && p.ListTitle) {
        for (const inst of this.hintListScope(p.ListTitle.Instances)) {
          if (
            inst.ValueSet?.Id === valueSetId
            && inst.ValueType === V2ParameterValueType.ValueSet
            && !this.isHintSourceField(inst)
          ) {
            return inst;
          }
          if (inst.ValueType === V2ParameterValueType.Record && inst.RecordFields?.length) {
            const found = this.findInstanceByValueSetId(inst.RecordFields, valueSetId);
            if (found) return found;
          }
        }
      }
    }
    return null;
  }

  // Выбор из подсказок поставил в поле имя члена набора, и текст поля теперь это оно, а
  // не набранный фильтр. На этом тексте держится предложение добавить значение: после
  // выбора добавлять нечего, значение уже взято из набора.
  private markPickedFromHints(picked: CommonEntity) {
    this.selectedValueCache = picked;
    this.sectionText = picked.Name;
  }

  @Watch("defhints")
  default_watcher() {
    if (!this.defhints.length || !this.templateId) {
      return;
    }
    const newParameters = reactive(_.cloneDeep(this.parameters));

    // set selected parameter on selection in the root component
    if (this.isRoot) {
      const templateParam: ParameterInstanceContainer =
        this.currentTemplateParam(newParameters);

      if (!templateParam) {
        return;
      }

      const ttl = templateParam.ListTitle;
      const insts = templateParam.Instance;

      if (
        templateParam.Type === ParameterInstanceContainerType.List &&
        ttl &&
        this.activeNestedIndex
      ) {
        const firstInstance = ttl.Instances[this.activeNestedIndex];
        if (firstInstance) {
          firstInstance.SelectedValue = this.defhints[0];
          firstInstance.StringValue = (this.defhints[0] as CommonEntity).Name;
          this.markPickedFromHints(this.defhints[0] as CommonEntity);

          if (this.templateId === 998) {
            this.componentStorageValue = this.defhints[0];
          } else {
            // очистить позицию если это не поле фильтра склада
            this.clearCurrentPositionMark();
          }
        }

        // make API call
        if (firstInstance && firstInstance.Id > 0) {
          this.editFieldValueRequest(
            firstInstance.Id,
            this.getEditRequest(firstInstance)
          );
        }
      } else if (
        templateParam.Type === ParameterInstanceContainerType.SingleInstance &&
        insts
      ) {
        insts.SelectedValue = this.defhints[0];
        insts.StringValue = (this.defhints[0] as CommonEntity).Name;
        this.markPickedFromHints(this.defhints[0] as CommonEntity);
        if (this.templateId === 998) {
          this.componentStorageValue = this.defhints[0];
        } else {
          // очистить позицию если это не поле фильтра склада
          if (this.templateId !== 999) {
            this.componentModel.vendorCode = "";
            if (
              newParameters &&
              newParameters[0] &&
              newParameters[0].Instance
            ) {
              newParameters[0].Instance.StringValue = "";
            }
            this.clearCurrentPositionMark();
          }
        }

        // make API call
        if (insts.Id > 0) {
          this.editFieldValueRequest(insts.Id, this.getEditRequest(insts));
        }
      }

      // Галки пишутся в строку активного поля, по всему её дочернему дереву.
      // Первое совпадение: TemplateId внутри строки один.
      if (this.customHintNotes.length > 0) {
        const rowFields = this.hintRowFields(newParameters);
        for (const [valueSetId, val] of this.customHintNotes) {
          const inst = rowFields
            ? this.findInstanceByValueSetId(rowFields, valueSetId)
            : null;
          if (inst) {
            inst.SelectedValue = { Id: val.Id, Name: val.Name };
            inst.StringValue = val.Name;
            if (inst.Id > 0) {
              this.editFieldValueRequest(inst.Id, this.getEditRequest(inst));
            }
          }
        }
        this.customHintNotes = [];
      }

      this.unsetWidths();
      this.$emit("update:modelValue", newParameters); // this.parameters
    }

    this.defhints.splice(0);
    this.closeMenu();
    this.releaseFieldFocus();
  }

  unsetWidths() {
    const inlineDescriptor = this.$refs["inlineDescriptor" + this.id] as any;
    if (inlineDescriptor) {
      // Ищем все td внутри компонента
      const tds = inlineDescriptor.$el.querySelectorAll("td[data-template-id]");
      tds.forEach((td: any) => {
        (td as HTMLElement).style.width = `unset`;
        (td as HTMLElement).style.minWidth = `unset`;
        (td as HTMLElement).style.maxWidth = `unset`;
      });
    }
  }

  // Значок в поле и кнопка подсказки зовут одно добавление.
  // Его делает корень: у него текст поля и запись созданного члена в модель.
  onAddValue() {
    if (this.isRoot) {
      this.addNewCreated();
      return;
    }
    this.$emit("add-value");
  }

  // Набор расширяется только с подтверждением, значит перед созданием спрашиваем.
  // Подтверждение требует сам набор, поэтому режим отображения тут ни при чём.
  // Из пустого текста создавать нечего, такой вызов проходит мимо подтверждения.
  private needsAddConfirm(): boolean {
    if (!this.isRoot) return false;
    if (this.activeValueType !== V2ParameterValueType.ValueSet) return false;
    if (!(this.sectionText || "").trim()) return false;
    return (
      this.hintedSetTypeFromSelector ===
      V2ParameterValueSetExtensionType.ExtendableOnApply
    );
  }

  // Окно встаёт у ячейки, под её нижней границей и по центру по горизонтали: добавление
  // приходит и по кнопке, и по значку, и по Enter, а точка должна быть одна и та же.
  // Ширина нужна для центрирования, поэтому она задаётся явно, а не берётся по умолчанию.
  // В границы экрана окно вписывает сам попап.
  private openAddConfirm() {
    const rect = this.fieldRect();
    this.addConfirmText = (this.sectionText || "").trim();
    this.addConfirmPos = rect
      ? {
          x: Math.round(rect.left + rect.width / 2 - this.addConfirmWidth / 2),
          y: Math.round(rect.bottom + 6),
        }
      : { x: 0, y: 0 };
    this.addConfirmOpen = true;
  }

  confirmAddValue() {
    this.addConfirmOpen = false;
    this.addNewCreated(true);
  }

  // Не подтвердили, значит в набор ничего не добавлялось. Блок обновляется целиком, тем же
  // путём, что значок обновления: модель приходит с сервера и набранный текст уходит вместе
  // с ней, поэтому локально значение не возвращаем, только закрываем поле.
  cancelAddValue() {
    this.addConfirmOpen = false;
    this.closeMenu();
    this.releaseFieldFocus();
    this.$emit("title-action", { action: "refresh" });
  }

  // Кнопка в подсказке, пока идёт запрос, не отвечает, как плюс и очистка. Значки гасит
  // признак в разметке, а у кнопки такого нет, поэтому проверка стоит у самой кнопки.
  onHintHeaderAdd() {
    if (this.valueRequestPending) return;
    this.addNewCreated();
  }

  addNewCreated(confirmed = false) {
    if (!confirmed && this.needsAddConfirm()) {
      this.openAddConfirm();
      return;
    }
    this.closeMenu();
    this.selectedValueCache = null;

    try {
      this.applyNewCreated();
    } finally {
      this.releaseFieldFocus();
    }
  }

  private applyNewCreated() {
    if (!this.parameters) {
      return;
    }

    const templateParam: ParameterInstanceContainer = this.currentTemplateParam(
      this.parameters
    );
    if (!templateParam) {
      return;
    }

    const ttl = templateParam.ListTitle;
    const insts = templateParam.Instance;

    if (
      templateParam.Type === ParameterInstanceContainerType.List &&
      ttl &&
      this.activeNestedIndex
    ) {
      const firstInstance = ttl.Instances[this.activeNestedIndex];
      // make API call
      if (firstInstance) {
        if (firstInstance.Id > 0) {
          const request = this.getEditRequest(firstInstance);
          this.keepCreatedSelection(firstInstance, request);
          this.editFieldValueRequest(firstInstance.Id, request);
        } else {
          if (!this.sectionText) {
            firstInstance.SelectedValue = null;
            firstInstance.StringValue = '';
            this.selectedValueCache = null;
            this.$emit("update:modelValue", reactive(_.cloneDeep(this.parameters)));
            this.clearCurrentPositionMark();
            return;
          }
          firstInstance.SelectedValue = {
            Id: undefined,
            Name: this.sectionText,
          };
          firstInstance.StringValue = this.sectionText;
        }
      }
    } else if (
      templateParam.Type === ParameterInstanceContainerType.SingleInstance &&
      insts
    ) {
      // make API call
      if (insts.Id > 0) {
        const request = this.getEditRequest(insts);
        this.keepCreatedSelection(insts, request);
        this.editFieldValueRequest(insts.Id, request);
      } else {
        if (!this.sectionText) {
          insts.SelectedValue = null;
          insts.StringValue = '';
          this.selectedValueCache = null;
          this.$emit("update:modelValue", reactive(_.cloneDeep(this.parameters)));
          this.clearCurrentPositionMark();
          return;
        }
        insts.SelectedValue = {
          Id: undefined,
          Name: this.sectionText,
        };
        insts.StringValue = this.sectionText;
      }
    }

    this.clearCurrentPositionMark();
  }

  // Фокус снимает описатель: каретка живёт в нём, а у записи во вложенном.
  // В строчном режиме поле не отпускается, там каретка остаётся.
  releaseFieldFocus() {
    if (!this.isTable) return;
    const inlineDescriptor = this.$refs["inlineDescriptor" + this.id] as
      | { releaseActiveField?: () => void }
      | undefined;
    inlineDescriptor?.releaseActiveField?.();
  }

  // Blur вернёт SelectedValue из кэша и очистит StringValue.
  // Имя то, что видно в поле: строка, целое, десятичное и дата.
  // Тело запроса к этому моменту уже собрано, число и дата ушли своими полями.
  private keepCreatedSelection(
    inst: ParameterInstance,
    request: {
      NewCreatedValue?: {
        NameString?: string | null;
        NameNumber?: number | null;
        NameDate?: string | null;
      } | null;
    } | null
  ) {
    const created = request?.NewCreatedValue;
    if (!created || !this.sectionText) return;
    if (
      !created.NameString &&
      created.NameNumber == null &&
      !created.NameDate
    ) {
      return;
    }
    const selected = { Id: undefined, Name: this.sectionText };
    inst.SelectedValue = selected;
    this.selectedValueCache = _.cloneDeep(selected);
  }

  /** Резерв снизу под «все данные загружены»: меньше, если нет кнопки/заголовка (только в этой подсказке). */
  private get leftReservePx(): number {
    return this.templateId === 998 ? 12 : 16;
  }
  private get rightReservePx(): number {
    return this.templateId === 998 ? 20 : 16;
  }

  /** Обновляет leftSelectorHeightPx по текущей высоте обёртки (вызывается при открытии и при изменении размера). */
  updateLeftSelectorHeightPx() {
    const el = this.$refs.leftSelectorWrapper as HTMLElement | undefined;
    if (el) {
      const h = el.offsetHeight;
      this.leftSelectorHeightPx = Math.max(0, h - this.leftReservePx);
    } else {
      this.leftSelectorHeightPx = 0;
    }
  }

  /** Обновляет rightSelectorHeightPx по текущей высоте обёртки. */
  updateRightSelectorHeightPx() {
    const el = this.$refs.rightSelectorWrapper as HTMLElement | undefined;
    if (el) {
      this.rightSelectorHeightPx = Math.max(0, el.offsetHeight - this.rightReservePx);
    } else {
      this.rightSelectorHeightPx = 0;
    }
  }

  /** Измеряет высоту левого блока подсказки (сразу, повторно после загрузки, и по ResizeObserver). */
  measureLeftSelectorHeight() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.updateLeftSelectorHeightPx();
        const el = this.$refs.leftSelectorWrapper as HTMLElement | undefined;
        if (el) {
          this.leftResizeObserver?.disconnect();
          this.leftResizeObserver = new ResizeObserver(() => {
          requestAnimationFrame(() => this.updateLeftSelectorHeightPx());
        });
          this.leftResizeObserver.observe(el);
        }
      }, 50);
      setTimeout(() => this.updateLeftSelectorHeightPx(), 450);
    });
  }

  /** Измеряет высоту правого блока подсказки (сразу, повторно после загрузки, и по ResizeObserver). */
  measureRightSelectorHeight() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.updateRightSelectorHeightPx();
        const el = this.$refs.rightSelectorWrapper as HTMLElement | undefined;
        if (el) {
          this.rightResizeObserver?.disconnect();
          this.rightResizeObserver = new ResizeObserver(() => {
          requestAnimationFrame(() => this.updateRightSelectorHeightPx());
        });
          this.rightResizeObserver.observe(el);
        }
      }, 50);
      setTimeout(() => this.updateRightSelectorHeightPx(), 450);
    });
  }

  beforeUnmount() {
    this.leftResizeObserver?.disconnect();
    this.rightResizeObserver?.disconnect();
  }

  handleUpdateMenu(value: {
    fieldKey: string | null;
    sectionText: string;
    eventKind: number;
    opts: any | undefined;
    nestedIndex: number | undefined;
  }) {
    const sectionChanged =
      this.templateId !== value.opts?.TemplateId ||
      this.activeNestedIndex !== value.nestedIndex;

    const newParameters = reactive(_.cloneDeep(this.parameters));

    if (sectionChanged && this.selectedValueCache && this.isRoot) {
      const oldTemplateParam = this.currentTemplateParam(newParameters);
      if (oldTemplateParam) {
        const ttl = oldTemplateParam.ListTitle;
        const insts = oldTemplateParam.Instance;
        if (
          oldTemplateParam.Type === ParameterInstanceContainerType.List &&
          ttl && this.activeNestedIndex
        ) {
          const inst = ttl.Instances[this.activeNestedIndex];
          if (inst) {
            inst.SelectedValue = this.selectedValueCache;
            inst.StringValue = "";
          }
        } else if (
          oldTemplateParam.Type === ParameterInstanceContainerType.SingleInstance &&
          insts
        ) {
          insts.SelectedValue = this.selectedValueCache;
          insts.StringValue = "";
        }
        this.selectedValueCache = null;
      }
    }

    this.fieldKey = value.fieldKey;
    this.sectionText = value.sectionText;
    this.fieldEditing = value.eventKind !== 1;
    this.templateId = value.opts?.TemplateId;
    this.activeNestedIndex = value.nestedIndex;
    this.instanceId = value.opts?.InstanceId;
    this.activeValueType = value.opts?.ValueType;
    if (sectionChanged) {
      this.hintedSetTypeFromSelector = undefined;
      this.defaultHintsLoaded = null;
      this.createdInSetText = null;
      this.rightSelectorHasData = null;
      this.clearNoMatchHint();
    }

    if (this.templateId && this.templateId !== 999 && this.activeValueType === 4) {
      this.measureLeftSelectorHeight();
    } else {
      this.leftSelectorHeightPx = 0;
    }
    if (this.showRightHintsColumn || ((this.showCustom || this.useCustomHints) && this.templateId !== 998)) {
      this.measureRightSelectorHeight();
    } else {
      this.rightSelectorHeightPx = 0;
    }

    // Ввод текста (input): только планируем дебаунс 300 мс
    if (this.isRoot && this.debouncedFilterUpdate && value.eventKind === 0) {
      this.debouncedFilterUpdate();
    }

    if (this.isRoot) {
      this.$nextTick(() => {
        // Смена секции / открытие меню: сперва обновляем фильтр, потом открываем меню — селекторы получат уже актуальный фильтр
        if (value.eventKind !== 0 && value.eventKind !== 1) {
          this.debouncedFilterUpdate?.cancel();
          this.applyFilterUpdate();
        }
        const inlineDescriptor = this.$refs[
          "inlineDescriptor" + this.id
        ] as any;
        if (inlineDescriptor) {
          this.unsetWidths();

          if (value.eventKind === 1) {
            inlineDescriptor.hideMenu();
            this.componentModel.container = null;

            // обработка события blur на меню. Если maintainStringValue, либо это служебное поле (например, артикул) или не ValueSet,
            // то нужно закрепить StringValue в модели и обнулить SelectedValue, иначе надо оставить выбранное значение (пользователь
            // использовал StringValue лишь в качестве фильтра и не выбрал ничего иного, либо выбрал из подсказок в методах defhints, positions)
            // и теперь StringValue нужно вернуть на это значение, либо очистить если SelectedValue не выбрано
            const templateParam: ParameterInstanceContainer =
              this.currentTemplateParam(newParameters);
            if (!templateParam) {
              return;
            }

            const ttl = templateParam.ListTitle;
            const insts = templateParam.Instance;

            // инстанс, который коммитим по blur (число): нужен для editField после единственного emit
            let committedInst: ParameterInstance | undefined;

            if (
              templateParam.Type === ParameterInstanceContainerType.List &&
              ttl &&
              this.activeNestedIndex != null
            ) {
              const firstInstance = ttl.Instances[this.activeNestedIndex];
              if (firstInstance) {
                if (
                  this.maintainStringValue ||
                  (this.templateId === 999 ||
                    !value.opts ||
                    this.activeValueType !== V2ParameterValueType.ValueSet)
                ) {
                  firstInstance.SelectedValue = this.selectedValueCache ?? null;
                } else {
                  firstInstance.SelectedValue = this.selectedValueCache;
                  firstInstance.StringValue = "";
                }
                this.selectedValueCache = null;
                // число: свежее значение берём прямо из события (value.sectionText),
                // клон this.parameters на этот момент может быть устаревшим
                if (
                  firstInstance.ValueType === V2ParameterValueType.Int ||
                  firstInstance.ValueType === V2ParameterValueType.Double
                ) {
                  firstInstance.NumberValue = this.ParameterInstanceFromValue(
                    firstInstance,
                    value.sectionText
                  ).NumberValue;
                }
                committedInst = firstInstance;
              }
            } else if (
              templateParam.Type ===
                ParameterInstanceContainerType.SingleInstance &&
              insts
            ) {
              if (
                this.maintainStringValue ||
                (this.templateId === 999 ||
                  !value.opts ||
                  this.activeValueType !== V2ParameterValueType.ValueSet)
              ) {
                insts.SelectedValue = this.selectedValueCache ?? null;
              } else {
                insts.SelectedValue = this.selectedValueCache;
                insts.StringValue = "";
              }
              this.selectedValueCache = null;
              if (
                insts.ValueType === V2ParameterValueType.Int ||
                insts.ValueType === V2ParameterValueType.Double
              ) {
                insts.NumberValue = this.ParameterInstanceFromValue(
                  insts,
                  value.sectionText
                ).NumberValue;
              }
              committedInst = insts;
            }

            // emit model value so that the parent has actual state
            this.$emit("update:modelValue", newParameters);

            // персист элементарного значения в edit: emit выше единственный, тут только запрос.
            // В create это no-op (Id <= 0). Чистая String идёт этой же веткой (подсказок у неё нет),
            // кроме поисковых фильтров 999/998 - их PATCHить нельзя.
            if (
              committedInst &&
              committedInst.Id > 0 &&
              (committedInst.ValueType === V2ParameterValueType.Int ||
                committedInst.ValueType === V2ParameterValueType.Double ||
                (committedInst.ValueType === V2ParameterValueType.String &&
                  this.templateId !== 999 &&
                  this.templateId !== 998))
            ) {
              this.editFieldValueRequest(
                committedInst.Id,
                this.getEditRequest(committedInst)
              );
            }
          } else {
            // ValueSet-подсказки открываем всегда; режим поиска позиций (showCustom без
            // useCustomHints) - тоже по всем полям, как и раньше. А в useCustomHints
            // (кастомные подсказки) простые текстовые/числовые поля меню не открывают.
            const isValueSetField =
              this.templateId !== 999 &&
              value.opts &&
              this.activeValueType === V2ParameterValueType.ValueSet;
            const positionsSearchMode = this.showCustom && !this.useCustomHints;
            if (isValueSetField || positionsSearchMode) {
              const positionTarget = (this.showCustom || this.useCustomHints) && this.templateId !== 998 ? "container" : "section";
              inlineDescriptor.openMenu(positionTarget);
            }

            // обработка события input. Если maintainStringValue, либо это служебное поле (например, артикул) или не ValueSet,
            // то нужно обновлять StringValue в модели
            // if (newParameters) {
              // clear selected value as text input event occurred
              const templateParam: ParameterInstanceContainer =
                this.currentTemplateParam(newParameters);
              if (!templateParam) {
                return;
              }

              const ttl = templateParam.ListTitle;
              const insts = templateParam.Instance;

              // инстанс, который коммитим на изменение (Bool/Date, eventKind=2)
              let committedInst: ParameterInstance | undefined;

              if (
                templateParam.Type === ParameterInstanceContainerType.List &&
                ttl &&
                this.activeNestedIndex != null
              ) {
                const firstInstance = ttl.Instances[this.activeNestedIndex];
                if (firstInstance) {
                  if (
                    !this.maintainStringValue &&
                    (this.templateId !== 999 &&
                      value.opts &&
                      this.activeValueType === V2ParameterValueType.ValueSet)
                  ) {
                    if (firstInstance.SelectedValue) {
                      this.selectedValueCache = _.cloneDeep(firstInstance.SelectedValue);
                    }
                  }
                  if (value.eventKind === 0) {
                    firstInstance.StringValue = value.sectionText;
                    firstInstance.SelectedValue = null;
                  }
                  // Bool/Date коммитятся на изменение (eventKind=2), значение из события
                  if (value.eventKind === 2) {
                    if (firstInstance.ValueType === V2ParameterValueType.Bool) {
                      firstInstance.BoolValue = this.ParameterInstanceFromValue(
                        firstInstance,
                        value.sectionText
                      ).BoolValue;
                    } else if (firstInstance.ValueType === V2ParameterValueType.Date) {
                      firstInstance.DateValue = value.sectionText
                        ? new Date(value.sectionText)
                        : null;
                    }
                  }
                  committedInst = firstInstance;
                }
              } else if (
                templateParam.Type ===
                  ParameterInstanceContainerType.SingleInstance &&
                insts
              ) {
                if (
                  !this.maintainStringValue &&
                  (this.templateId !== 999 &&
                    value.opts &&
                    this.activeValueType === V2ParameterValueType.ValueSet)
                ) {
                  if (insts.SelectedValue) {
                     this.selectedValueCache = _.cloneDeep(insts.SelectedValue);
                  }
                }
                if (value.eventKind === 0) {
                  insts.StringValue = value.sectionText;
                  insts.SelectedValue = null;
                }
                if (value.eventKind === 2) {
                  if (insts.ValueType === V2ParameterValueType.Bool) {
                    insts.BoolValue = this.ParameterInstanceFromValue(
                      insts,
                      value.sectionText
                    ).BoolValue;
                  } else if (insts.ValueType === V2ParameterValueType.Date) {
                    insts.DateValue = value.sectionText
                      ? new Date(value.sectionText)
                      : null;
                  }
                }
                committedInst = insts;
              }

              if (value.eventKind === 0) {
                if (this.activeValueType !== V2ParameterValueType.ValueSet || this.templateId === 999) {
                  this.clearCurrentPositionMark();
                }
              }
              this.$emit("update:modelValue", newParameters); // this.parameters

              // персист Bool/Date в edit на изменение: emit выше единственный, тут только запрос.
              if (
                value.eventKind === 2 &&
                committedInst &&
                (committedInst.ValueType === V2ParameterValueType.Bool ||
                  committedInst.ValueType === V2ParameterValueType.Date) &&
                committedInst.Id > 0
              ) {
                this.editFieldValueRequest(
                  committedInst.Id,
                  this.getEditRequest(committedInst)
                );
              }
            // }
          }
        }
      });
    } else {
      this.$emit("update:nested", value);
    }
  }

  // Условие по шаблону нужно набору текста, пока в артикуле печатают, гасить его нельзя.
  // Очистка просит погасить прямо, там артикул не соответствует позиции в любом случае.
  clearCurrentPositionMark(wipeVendorCode = this.templateId !== 999) {
    if (this.isRoot) {
      const newParameters = reactive(_.cloneDeep(this.parameters));

      if (wipeVendorCode) {
        this.componentModel.vendorCode = "";
        if (
          newParameters &&
          newParameters[0] &&
          newParameters[0].Instance
        ) {
          newParameters[0].Instance.StringValue = "";
          this.$emit("update:modelValue", newParameters); // this.parameters
        }
      }

      this.currentStoragePos = {
        currentPosId: 0,
        currentPosPrice: 0,
        currentPosPriceType: 0,
        currentPosUnit: 0,
        currentPosStorages: [],
      };
      this.$emit("storagePosChange", this.currentStoragePos);
    }
  }

  private getEditRequest(insts: ParameterInstance) {
    switch (insts.ValueType) {
      case V2ParameterValueType.String:
        return {
          StringValue: insts.StringValue || '',
        };
      case V2ParameterValueType.Int:
        // приоритет уже сохранённого NumberValue; иначе парсим текущий текст.
        // после сохранения StringValue пуст, число живёт в NumberValue
        return {
          NumberValue:
            insts.NumberValue ??
            (isNumeric(insts.StringValue + "")
              ? +parseInt("" + insts.StringValue)
              : null),
        };
      case V2ParameterValueType.Double:
        return {
          NumberValue:
            insts.NumberValue ??
            (isNumericFloat(insts.StringValue + "")
              ? +parseFloat(("" + insts.StringValue).replace(",", "."))
              : isNumeric(insts.StringValue + "")
              ? +parseInt("" + insts.StringValue)
              : null),
        };
      case V2ParameterValueType.Bool:
        return {
          BoolValue: insts.BoolValue ?? null,
        };
      case V2ParameterValueType.Date:
        // элементарная дата живёт в DateValue, StringValue для неё не заполняется;
        // new Date("").toISOString() бросил бы RangeError
        return {
          DateValue: insts.DateValue
            ? new Date(insts.DateValue).toISOString()
            : null,
        };
      case V2ParameterValueType.ValueSet:
        if (!insts.ValueSet) {
          return {
            SelectedValueId: null,
          };
        } else if (insts.SelectedValue?.Id) {
          return {
            SelectedValueId: insts.SelectedValue.Id || null,
          };
        } else if (insts.SelectedValue?.Name || insts.StringValue) {
          switch (insts.ValueSet.ValueType) {
            case V2ParameterValueSet_ValueType.String:
              return {
                NewCreatedValue: {
                  NameString: insts.SelectedValue?.Name || insts.StringValue,
                },
              };
            // falls through
            case V2ParameterValueSet_ValueType.Int:
              return {
                NewCreatedValue: {
                  NameNumber: isNumeric(
                    (insts.SelectedValue?.Name || insts.StringValue) + ""
                  )
                    ? +parseInt(
                        "" + (insts.SelectedValue?.Name || insts.StringValue)
                      )
                    : null,
                },
              };
            case V2ParameterValueSet_ValueType.Decimal:
              return {
                NewCreatedValue: {
                  NameNumber: isNumericFloat(
                    (insts.SelectedValue?.Name || insts.StringValue) + ""
                  )
                    ? +parseFloat(
                        (
                          "" + (insts.SelectedValue?.Name || insts.StringValue)
                        ).replace(",", ".")
                      )
                    : isNumeric(
                        (insts.SelectedValue?.Name || insts.StringValue) + ""
                      )
                    ? +parseInt(
                        "" + (insts.SelectedValue?.Name || insts.StringValue)
                      )
                    : null,
                },
              };
            case V2ParameterValueSet_ValueType.Date:
              return {
                NewCreatedValue: {
                  NameDate: new Date(
                    (insts.SelectedValue?.Name || insts.StringValue) + ""
                  ).toISOString(),
                },
              };
            default:
              return null;
          }
        } else {
          return {
            SelectedValue: null,
          };
        }
      default:
        return null;
    }
  }

  // Поле записи уходит в field-value, верхнеуровневой параметр в parameter-value.
  // Корень держит модель целиком, и поле записи лежит у него внутри RecordFields.
  // Вложенный уровень это тело записи, его модель уже RecordFields, поэтому обход
  // там начинается внутри записи.
  private isRecordFieldInstance(id: number): boolean {
    const search = (
      containers: ParameterInstanceContainer[],
      insideRecord: boolean
    ): boolean | null => {
      for (const p of containers) {
        if (
          p.Type === ParameterInstanceContainerType.SingleInstance &&
          p.Instance
        ) {
          const inst = p.Instance;
          if (inst.Id === id) return insideRecord;
          if (
            inst.ValueType === V2ParameterValueType.Record &&
            inst.RecordFields?.length
          ) {
            const r = search(inst.RecordFields, true);
            if (r !== null) return r;
          }
        } else if (
          p.Type === ParameterInstanceContainerType.List &&
          p.ListTitle
        ) {
          for (const inst of p.ListTitle.Instances) {
            if (!inst) continue;
            if (inst.Id === id) return insideRecord;
            if (
              inst.ValueType === V2ParameterValueType.Record &&
              inst.RecordFields?.length
            ) {
              const r = search(inst.RecordFields, true);
              if (r !== null) return r;
            }
          }
        }
      }
      return null;
    };
    return search(this.parameters, !this.isRoot) === true;
  }

  // Пока идёт запрос по значению, плюс, очистка и кнопка добавления в подсказке не отвечают.
  // Счётчик, а не признак: выбор кастомной подсказки шлёт по запросу на каждую галку.
  private valueRequests = 0;

  get valueRequestPending(): boolean {
    return this.valueRequests > 0;
  }

  private async editFieldValueRequest(id: number, value: any) {
    if (this.createMode) {
      return;
    }
    this.valueRequests += 1;
    try {
      await this.sendFieldValueRequest(id, value);
    } finally {
      this.valueRequests -= 1;
    }
  }

  private async sendFieldValueRequest(id: number, value: any) {
    const created = value?.NewCreatedValue;
    const templateId = this.templateId;
    const submittedText = this.sectionText;
    const isField = this.isRecordFieldInstance(id);
    // поле записи -> field-value, верхнеуровневой параметр -> parameter-value
    const data = isField
      ? await this.parameter_store.editField(id, value)
      : await this.parameter_store.editParameterValue(id, value);
    if (!created || !this.isRoot || data?.response_ok === false) {
      return;
    }
    // Добавление прошло, значит значение с этим текстом в наборе уже есть. Выдачу под
    // него не перезапрашиваем, поэтому признак ставим по ответу.
    if (submittedText.trim()) this.createdInSetText = submittedText;
    await this.applyCreatedMember(
      id,
      templateId,
      isField,
      created,
      data,
      submittedText
    );
  }

  // Член, созданный без id, пишется в модель корня: вложенный уровень запрос не шлёт,
  // а id вхождения от этого не меняется, схема не пересобирается.
  // Поле уже могло сменить текст, пока шёл запрос: тогда запись не кладём.
  // Видимый текст: StringValue, а после blur SelectedValue.Name.
  // Сверяем его с текстом, который ушёл в добавление, для строки, числа и даты.
  private async applyCreatedMember(
    id: number,
    templateId: number | undefined,
    isField: boolean,
    created: { NameString?: string; NameNumber?: number; NameDate?: string },
    data: any,
    submittedText: string
  ) {
    const name = this.createdMemberName(created);
    const fromResponse = this.memberFromEditResponse(data);
    let member = fromResponse?.Id ? fromResponse : null;
    if (!member && name) {
      const found = await this.parameter_store.findValueSetMember(
        id,
        !isField,
        name
      );
      if (found?.Id) member = { Id: found.Id, Name: found.Name };
    }
    if (!member?.Id) return;

    const model = reactive(_.cloneDeep(this.parameters));
    const container = this.currentTemplateParam(model, templateId, id);
    const inst = this.instanceById(container, id);
    if (!inst || inst.SelectedValue?.Id) return;
    const shown = inst.StringValue || inst.SelectedValue?.Name || "";
    const keptName = member.Name || submittedText || name;
    if (shown !== submittedText && shown !== member.Name) return;
    inst.SelectedValue = { Id: member.Id, Name: keptName };
    inst.StringValue = keptName;
    // Blur возвращает кэш. Там должен остаться этот член, уже с id.
    if (
      !this.selectedValueCache?.Id &&
      (this.selectedValueCache?.Name === submittedText ||
        this.selectedValueCache?.Name === keptName)
    ) {
      this.selectedValueCache = { Id: member.Id, Name: keptName };
    }
    this.$emit("update:modelValue", model);
  }

  private createdMemberName(created: {
    NameString?: string;
    NameNumber?: number;
    NameDate?: string;
  }): string {
    if (created.NameString) return created.NameString;
    if (created.NameNumber != null) return String(created.NameNumber);
    if (created.NameDate) return String(created.NameDate);
    return "";
  }

  private memberFromEditResponse(data: any): { Id: number; Name: string } | null {
    const selected =
      data?.SelectedValue || data?.Container?.SelectedValue || data?.Instance?.SelectedValue;
    if (selected?.Id) return { Id: selected.Id, Name: selected.Name };
    return null;
  }

  private instanceById(
    container: ParameterInstanceContainer | undefined,
    id: number
  ): ParameterInstance | null {
    if (!container) return null;
    if (container.Instance?.Id === id) return container.Instance;
    const fromList = container.ListTitle?.Instances?.find((item) => item?.Id === id);
    return fromList || null;
  }

  private createSchema(
    params: ParameterInstanceContainer[],
    indexPrefix: string = ""
  ): SchemaField[] {
    const schema: SchemaField[] = [];

    params.forEach((param) => {
      const ttl = param.ListTitle;
      const insts = param.Instance;
      if (param.Type === ParameterInstanceContainerType.List && ttl) {
        // take the 1st instance as they should be the same structure in the list
        const firstInstance = ttl.Instances[0];
        const templateId = firstInstance?.TemplateId;
        const nestedSchema = ttl.Instances.map((item, nestedIndex) => {
          const newPrefix = indexPrefix + nestedIndex;
          return this.ParameterInstanceToSchemaField(
            item,
            `param_${templateId}_${newPrefix}`,
            ttl.Name
          );
        });

        schema.push(
          this.ParameterInstanceToSchemaField(
            undefined,
            `param_${templateId}_${indexPrefix}arr`,
            "",
            nestedSchema,
            ttl.Id
          )
        );
        // console.log('push arr '+`param_${templateId}_${indexPrefix}arr`)
        // console.log(param)
      } else if (insts) {
        const templateId = insts.TemplateId;
        schema.push(
          this.ParameterInstanceToSchemaField(
            insts,
            `param_${templateId}_${indexPrefix}`,
            "",
            undefined
          )
        );
      }
    });

    return schema;
  }

  private getTypeFromValueType(valueType: V2ParameterValueType): string {
    switch (valueType) {
      case V2ParameterValueType.String:
        return "string";
      case V2ParameterValueType.Int:
        return "int";
      case V2ParameterValueType.Double:
        return "double";
      // case V2ParameterValueType.Date:
      // return "date";
      case V2ParameterValueType.ValueSet:
        return "select";
      case V2ParameterValueType.Record:
      case V2ParameterValueType.Bool:
      case V2ParameterValueType.Date:
        return "nested";
      default:
        return "string";
    }
  }

  private getInputPatternFromValueType(
    valueType: V2ParameterValueType,
    valueSetType: V2ParameterValueSet_ValueType
  ): RegExp | undefined {
    switch (valueType) {
      case V2ParameterValueType.String:
        return undefined;
      case V2ParameterValueType.Int:
        return /^[0-9]+$/;
      case V2ParameterValueType.Double:
        return /[0-9.]/;
      case V2ParameterValueType.ValueSet:
        switch (valueSetType) {
          case V2ParameterValueSet_ValueType.Int:
            return /^[0-9]+$/;
          case V2ParameterValueSet_ValueType.Decimal:
            return /[0-9.]/;
          default:
            return undefined;
        }
      default:
        return undefined;
    }
  }

  createModelValue(
    params: ParameterInstanceContainer[],
    indexPrefix: string = "",
    modelValue: Record<string, any> = {}
  ): Record<string, any> {
    params.forEach((param) => {
      const ttl = param.ListTitle;
      const insts = param.Instance;
      if (
        param.Type === ParameterInstanceContainerType.List &&
        ttl &&
        ttl.Instances.length
      ) {
        // take the 1st instance as they should be the same structure in the list
        const firstInstance = ttl.Instances[0];
        const templateId = firstInstance.TemplateId;

        const key = `param_${templateId}_${indexPrefix}arr`;
        if (
          firstInstance.ValueType === V2ParameterValueType.Record &&
          firstInstance.RecordFields
        ) {
          modelValue[key] = ttl.Instances.map(
            (item) => item.RecordFields || []
          );
        } else if (
          firstInstance.ValueType === V2ParameterValueType.Bool ||
          firstInstance.ValueType === V2ParameterValueType.Date
        ) {
          modelValue[key] = ttl.Instances;
        } else {
          const nestedModel = ttl.Instances.map((item) => {
            // use any item here as they should be always equal to the first one concerning structure
            const value = this.ParameterInstanceToValue(item);
            const tokens = (value.match(/(\s+|[^\s]+)/g) || []).map(
              (tok, index) => ({
                text: tok,
                type: "string",
                clickable: item.ValueType === V2ParameterValueType.ValueSet,
              })
            );
            const fullTokens: Token[] = [];
            tokens.forEach((token, index) => {
              if (/\s+/.test(token.text)) {
                fullTokens.push({ text: " ", type: "space", clickable: false });
              } else {
                fullTokens.push(token);
              }
            });
            return fullTokens;
          });
          modelValue[key] = nestedModel;
        }
      } else if (
        insts &&
        insts.ValueType === V2ParameterValueType.Record &&
        insts.RecordFields
      ) {
        const templateId = insts.TemplateId;
        const key = `param_${templateId}_${indexPrefix}`;
        modelValue[key] = insts.RecordFields;
      } else if (
        insts &&
        (insts.ValueType === V2ParameterValueType.Bool ||
          insts.ValueType === V2ParameterValueType.Date)
      ) {
        const templateId = insts.TemplateId;
        const key = `param_${templateId}_${indexPrefix}`;
        modelValue[key] = insts;
      } else if (insts) {
        const value = this.ParameterInstanceToValue(insts);

        const tokens = (value.match(/(\s+|[^\s]+)/g) || []).map(
          (tok: string, index: number) => ({
            text: tok,
            type: "string",
            clickable: insts.ValueType === V2ParameterValueType.ValueSet,
          })
        );
        const fullTokens: Token[] = [];
        tokens.forEach((token: Token, index: number) => {
          if (/\s+/.test(token.text)) {
            fullTokens.push({ text: " ", type: "space", clickable: false });
          } else {
            fullTokens.push(token);
          }
        });
        const templateId = insts.TemplateId;
        const key = `param_${templateId}_${indexPrefix}`;
        modelValue[key] = fullTokens;
      }
    });

    return modelValue;
  }

  private updateParamsFromModel(
    params: ParameterInstanceContainer[],
    newModel: Record<string, any>,
    indexPrefix: string = ""
  ) {
    params.forEach((param) => {
      const ttl = param.ListTitle;
      const insts = param.Instance;

      const templateId =
        param.Type === ParameterInstanceContainerType.List &&
        ttl &&
        ttl.Instances.length
          ? ttl.Instances[0].TemplateId
          : insts?.TemplateId;
      const key =
        param.Type === ParameterInstanceContainerType.List
          ? `param_${templateId}_${indexPrefix}arr`
          : `param_${templateId}_${indexPrefix}`;
      if (newModel[key]) {
        if (
          param.Type === ParameterInstanceContainerType.List &&
          ttl &&
          ttl.Instances.length
        ) {
          // take the 1st instance as they should be the same structure in the list
          const firstInstance = ttl.Instances[0];
          if (
            firstInstance.ValueType === V2ParameterValueType.Record &&
            firstInstance.RecordFields
          ) {
            ttl.Instances.forEach((item, nestedIndex) => {
              item.RecordFields = newModel[key][nestedIndex] || [];
            });
          } else if (
            firstInstance.ValueType === V2ParameterValueType.Bool ||
            firstInstance.ValueType === V2ParameterValueType.Date
          ) {
            ttl.Instances.forEach((item, nestedIndex) => {
              // пишем обратно в элемент списка по индексу, присваивание в локальную item было no-op
              ttl.Instances[nestedIndex] = newModel[key][nestedIndex] || item;
            });
          } else {
            ttl.Instances = ttl.Instances.map((item, nestedIndex) => {
              if (
                newModel[key][nestedIndex] &&
                Array.isArray(newModel[key][nestedIndex])
              ) {
                return this.ParameterInstanceFromValue(
                  item,
                  newModel[key][nestedIndex]
                    .map((token: any) => token.text)
                    .join("")
                );
              } else {
                return item;
              }
            });
          }
        } else if (
          insts &&
          insts.ValueType === V2ParameterValueType.Record &&
          insts.RecordFields
        ) {
          insts.RecordFields = newModel[key] || [];
        } else if (
          insts &&
          (insts.ValueType === V2ParameterValueType.Bool ||
            insts.ValueType === V2ParameterValueType.Date)
        ) {
          param.Instance = newModel[key] || null;
        } else if (insts) {
          if (newModel[key] && Array.isArray(newModel[key])) {
            param.Instance = this.ParameterInstanceFromValue(
              insts,
              newModel[key].map((token: any) => token.text).join("")
            );
          }
        }
      }
    });
  }

  onEnter() {
    if (this.enterOnValueSetInTable()) return;

    let didSelect = false;
    const def = this.$refs.aux_selector_def as any;
    const custom = this.$refs.aux_selector_custom as any;
    if (def) {
      didSelect = def.selectCurrent();
    } else if (custom) {
      didSelect = custom.selectCurrent();
    }
    if (didSelect) {
      this.closeMenu();
      return;
    }
    if (this.noMatchToReport()) this.flashNoMatchHint();
  }

  // Enter нечего подтверждать: набор закрытый, значения с набранным текстом в нём нет,
  // строку в списке тоже не выбрали. Добавить такое значение нельзя, поэтому сообщаем.
  private noMatchToReport(): boolean {
    if (!this.isTable || !this.isRoot) return false;
    if (this.activeValueType !== V2ParameterValueType.ValueSet) return false;
    if (!(this.sectionText || "").trim()) return false;
    if (!this.hintsAnswerForSectionText || this.exactHintForSectionText) {
      return false;
    }
    return (
      this.hintedSetTypeFromSelector ===
      V2ParameterValueSetExtensionType.Closed
    );
  }

  private flashNoMatchHint() {
    const rect = this.fieldRect();
    if (!rect) return;
    this.noMatchHintRect = {
      x: Math.round(rect.left),
      y: Math.round(rect.top),
      w: Math.max(1, Math.round(rect.width)),
    };
    if (this.noMatchHintTimer) clearTimeout(this.noMatchHintTimer);
    this.showNoMatchHint = true;
    this.noMatchHintTimer = setTimeout(() => {
      this.noMatchHintTimer = undefined;
      this.showNoMatchHint = false;
    }, 1000);
  }

  private clearNoMatchHint() {
    if (this.noMatchHintTimer) {
      clearTimeout(this.noMatchHintTimer);
      this.noMatchHintTimer = undefined;
    }
    this.showNoMatchHint = false;
  }

  // Enter в таблице на наборном поле. Пока по списку ходят стрелками, Enter берёт
  // подсвеченную строку прежним путём. Иначе подтверждается точное совпадение, как по
  // клику по строке, а если его нет, у открытого набора Enter равен кнопке добавления
  // значения. Без выдачи ровно под набранный текст не делаем ни того, ни другого:
  // совпадение может существовать, просто ответ ещё не пришёл, и значение бы дублировалось.
  private enterOnValueSetInTable(): boolean {
    if (!this.isTable || !this.isRoot) return false;
    if (this.activeValueType !== V2ParameterValueType.ValueSet) return false;

    const selector = this.$refs.aux_selector_def as any;
    if (!selector || selector.keyboardSelectionActive?.()) return false;

    const text = (this.sectionText || "").trim();
    if (!text || !this.hintsAnswerForSectionText) return false;

    if (this.exactHintForSectionText) {
      if (!selector.selectByName?.(text)) return false;
      this.closeMenu();
      return true;
    }

    if (!this.addValueFieldKey) return false;
    this.onHintHeaderAdd();
    return true;
  }

  // Escape закрывает подсказку, и в таблице поле при этом отпускается: каретка в нём
  // не остаётся. В строчном режиме releaseFieldFocus выходит сразу, там всё как было.
  // Наборное поле в таблице закрывается полным путём, как по клику вне поля, чтобы
  // неизменённое значение вернулось из кэша. Отвечает тот описатель, в котором стоит
  // поле: у записи это вложенный экземпляр, поэтому решение принимает не корень.
  onEscape() {
    const inlineDescriptor = this.$refs["inlineDescriptor" + this.id] as
      | { closeValueSetFieldAsOutside?: () => boolean }
      | undefined;
    if (inlineDescriptor?.closeValueSetFieldAsOutside?.()) return;
    this.closeMenu();
    this.releaseFieldFocus();
  }

  fieldRect(): DOMRect | null {
    const inlineDescriptor = this.$refs["inlineDescriptor" + this.id] as
      | { activeFieldRect?: () => DOMRect | null }
      | undefined;
    return inlineDescriptor?.activeFieldRect?.() ?? null;
  }

  fieldArea(): HTMLElement | null {
    const inlineDescriptor = this.$refs["inlineDescriptor" + this.id] as
      | { activeFieldArea?: () => HTMLElement | null }
      | undefined;
    return inlineDescriptor?.activeFieldArea?.() ?? null;
  }

  // Уход из поля по просьбе внешнего уровня. Вложенные экземпляры дескриптор спрашивает
  // через childRefs.
  leaveField(): boolean {
    const inlineDescriptor = this.$refs["inlineDescriptor" + this.id] as
      | { leaveActiveField?: () => boolean }
      | undefined;
    return !!inlineDescriptor?.leaveActiveField?.();
  }

  // Разметку поля держит описатель, он же её и стирает. Вложенные экземпляры он
  // спрашивает через childRefs.
  eraseFieldMarkup(key: string): boolean {
    const inlineDescriptor = this.$refs["inlineDescriptor" + this.id] as
      | { eraseFieldMarkup?: (key: string) => boolean }
      | undefined;
    return !!inlineDescriptor?.eraseFieldMarkup?.(key);
  }

  // Вложенные экземпляры дескриптор спрашивает через childRefs
  closeValueSetFieldAsOutside(): boolean {
    const inlineDescriptor = this.$refs["inlineDescriptor" + this.id] as
      | { closeValueSetFieldAsOutside?: () => boolean }
      | undefined;
    return !!inlineDescriptor?.closeValueSetFieldAsOutside?.();
  }

  closeMenu() {
    this.clearNoMatchHint();
    const that = this;
    this.$nextTick(() => {
      const inlineDescriptor = that.$refs["inlineDescriptor" + that.id] as any;
      if (inlineDescriptor) {
        inlineDescriptor.hideMenu();
        this.componentModel.container = null;
      }
    });
  }

  // when the model is saved
  onUpdateModelValue(newModel: Record<string, any>) {
    const newParameters = reactive(_.cloneDeep(this.parameters));
    this.updateParamsFromModel(newParameters, newModel, this.indexPrefix);
    this.$emit("update:modelValue", newParameters); // this.parameters
  }

  /**
   * Возвращает кнопки списка в рабочее состояние после запроса. Описатель блокирует
   * нажатую кнопку и показывает индикацию, а сам снимает их только при пересборке
   * разметки, которой при неудачном запросе не будет.
   */
  private releaseListActionState(): void {
    const inlineDescriptor = this.$refs["inlineDescriptor" + this.id] as any;
    inlineDescriptor?.clearListActionState?.();
  }

  async addListItem(arg: {
    templateId: number;
    instanceId: number | undefined;
  }) {
    try {
      await this.applyAddListItem(arg);
    } finally {
      this.releaseListActionState();
    }
  }

  private async applyAddListItem({
    templateId,
    instanceId,
  }: {
    templateId: number;
    instanceId: number | undefined;
  }) {
    const newParameters = reactive(_.cloneDeep(this.parameters));
    console.log("add list item " + templateId + " " + instanceId);
    // otherwise copy first list instance to an empty structure
    const templateParamIndex = newParameters.findIndex(
      (p) =>
        p.Type === ParameterInstanceContainerType.List &&
        p.ListTitle?.Instances[0]?.TemplateId === templateId
    );
    const ttl = newParameters[templateParamIndex]?.ListTitle;

    if (templateParamIndex >= 0 && ttl && ttl.Instances.length) {
      // dont use API when the whole container is supposed to be a new item;
      // otherwise there is a risk of damaging existing parameters from the custom hints
      if (instanceId && !this.createMode) {
        // make API call
        const newParam = (
          await this.parameter_store.addListField(instanceId, !this.isRoot)
        ).Instance;

        // Вставляем новый элемент после последнего с таким templateId
        ttl.Instances.push(newParam || _.cloneDeep(ttl.Instances[0]));
      } else {
        // otherwise just push an empty parameter based on the first instance structure
        // TODO: make empty element based on this structure
        const newParam: ParameterInstance = createEmptyFromInstance(
          ttl.Instances[0],
          (instanceId || 0) + 1 + 1000
        ); // _.cloneDeep(ttl.Instances[0]);
        // newParam.StringValue = "";

        // if (
        // newParam.ValueType === V2ParameterValueType.Record &&
        // newParam.RecordFields
        // ) {
        // TODO: mapRecursive here creating empty structures based on the first elements of all nested lists and records
        // newParam.RecordFields = [];
        // } else {
        // newParam.RecordFields = [];
        // }
        // Вставляем новый элемент после последнего с таким templateId
        ttl.Instances.push(newParam);
      }
    }

    this.clearCurrentPositionMark();
    this.$emit("update:modelValue", newParameters);
  }

  async removeListItem(arg: {
    templateId: number;
    instanceId: number | undefined;
    index: number;
  }) {
    try {
      await this.applyRemoveListItem(arg);
    } finally {
      this.releaseListActionState();
    }
  }

  private async applyRemoveListItem({
    templateId,
    instanceId,
    index,
  }: {
    templateId: number;
    instanceId: number | undefined;
    index: number;
  }) {
    const newParameters = reactive(_.cloneDeep(this.parameters));
    // else just remove item at index
    console.log("remove item " + templateId + " - " + index);
    const templateParam = newParameters.find(
      (p) =>
        p.Type === ParameterInstanceContainerType.List &&
        p.ListTitle?.Instances[0]?.TemplateId === templateId
    );
    const ttl = templateParam?.ListTitle;
    if (templateParam && ttl) {
      // dont use API when the whole container is supposed to be a new item;
      // otherwise there is a risk of damaging existing parameters from the custom hints
      if (instanceId && !this.createMode) {
        // make API call
        await this.parameter_store.removeListField(instanceId, !this.isRoot);
      }
      ttl.Instances.splice(index, 1);
    }
    this.clearCurrentPositionMark();
    this.$emit("update:modelValue", newParameters); // this.parameters
  }

  customUpdateToken(token: Token, field: SchemaField): Token {
    // Адаптировать для типов параметров, если нужно
    return token;
  }

  // mapping helper functions

  private ParameterInstanceToSchemaField(
    item: ParameterInstance | undefined,
    key: string,
    title: string,
    nestedSchema: SchemaField[] | undefined = undefined,
    listId: number | undefined = undefined
  ): SchemaField {
    return {
      key,
      // Устойчивый признак единицы это вхождение, у списочного поля его роль играет
      // сам список. У только что добавленного элемента вхождения ещё нет, тогда
      // остаётся позиционный ключ поля и единица переживёт ответ сервера пересборкой
      unitKey:
        item && item.Id > 0
          ? `inst_${item.Id}`
          : listId
          ? `list_${listId}`
          : key,
      title,
      axis:
        item && item.RecordAxisType === V2RecordAxisType.Vertical
          ? "vertical"
          : "horizontal",
      type: item ? this.getTypeFromValueType(item.ValueType) : "",
      // Formula - только просмотр: секция станет нередактируемой через forbid_edit
      readonly: item ? item.ValueType === V2ParameterValueType.Formula : false,
      inputPattern: item
        ? this.getInputPatternFromValueType(
            item.ValueType,
            item.ValueSet?.ValueType || V2ParameterValueSet_ValueType.String
          )
        : undefined,
      options: item
        ? 
          [
            {
              InstanceId: item.Id,
              ValueType: item.ValueType,
              ValueSet: item.ValueSet,
              TemplateId: item.TemplateId,
              selectedId: item.SelectedValue?.Id,
            },
          ]
        : nestedSchema && nestedSchema.length
        ? [
            {
              InstanceId: listId,
              TemplateId:
                nestedSchema[0].options && nestedSchema[0].options.length
                  ? nestedSchema[0].options[0].TemplateId
                  : undefined,
            },
          ]
        : undefined,
      separator: item ? this.separators[0] : undefined,
      nestedSchema,
      allowDelete: false,
      prefix: undefined,
      isList: nestedSchema && nestedSchema.length ? true : false,
      placeholder: item ? item.Name : "",
      component:
        item && item.ValueType === V2ParameterValueType.Record
          ? this.$options.components?.ParameterInline
          : item && item.ValueType === V2ParameterValueType.Bool
          ? this.$options.components?.ParameterCheckbox
          : item && item.ValueType === V2ParameterValueType.Date
          ? this.$options.components?.ParameterDateField
          : undefined,
    };
  }

  private ParameterInstanceToValue(param: ParameterInstance): string {
    switch (param.ValueType) {
      case V2ParameterValueType.String:
        return param.StringValue || "";
      case V2ParameterValueType.Int:
      case V2ParameterValueType.Double:
        // при null поле должно быть пустым; 0 показываем как "0"
        return param.NumberValue != null ? "" + param.NumberValue : "";
      case V2ParameterValueType.Formula:
        return param.NumberValue ? "" + param.NumberValue : "";
      case V2ParameterValueType.Bool:
        return param.BoolValue != null
          ? param.BoolValue
            ? "true"
            : "false"
          : "null";
      case V2ParameterValueType.Date:
        return param.DateValue ? "" + param.DateValue : "";
      case V2ParameterValueType.ValueSet:
        switch (param.ValueSet?.ValueType) {
          case V2ParameterValueSet_ValueType.String:
          // falls through
          case V2ParameterValueSet_ValueType.Int:
          case V2ParameterValueSet_ValueType.Decimal:
            return param.SelectedValue?.Name || param.StringValue || "";
          case V2ParameterValueSet_ValueType.Date:
            return param.SelectedValue?.Name
              ? /*date.formatDate(
                  new Date("" + param.SelectedValue?.Name),
                  "DD.MM.YY"
                ) || "" */ "" + param.SelectedValue?.Name
              : param.StringValue || "";
          default:
            return param.StringValue || "";
        }
      default:
        return "";
    }
  }

  private ParameterInstanceFromValue(
    containerValue: ParameterInstance,
    fieldModel: any
  ): ParameterInstance {
    let res_value = {
      Id: containerValue.Id,
      Name: containerValue.Name,
      TemplateId: containerValue.TemplateId,
      Unremovable: containerValue.Unremovable,
      ValueDisplayType: containerValue.ValueDisplayType,
      ValueType: containerValue.ValueType,
      ValueSet: containerValue.ValueSet,
      RecordAxisType: containerValue.RecordAxisType,
      Round: containerValue.Round,
      RecordFields: containerValue.RecordFields,
    } as ParameterInstance;

    switch (containerValue.ValueType) {
      case V2ParameterValueType.String:
        res_value.StringValue = fieldModel || '';
        break;
      case V2ParameterValueType.Int:
        res_value.NumberValue = isNumeric(fieldModel) ? +fieldModel : null;
        break;
      case V2ParameterValueType.Double:
      case V2ParameterValueType.Formula:
        res_value.NumberValue = isNumericFloat(fieldModel) ? +fieldModel : null;
        break;
      case V2ParameterValueType.Bool:
        res_value.BoolValue =
          fieldModel === "true" ? true : fieldModel === "false" ? false : null;
        break;
      case V2ParameterValueType.Date:
        res_value.DateValue = date.extractDate(
          fieldModel,
          "DD.MM.YY",
          undefined
        );
        break;
      case V2ParameterValueType.ValueSet:
        res_value.SelectedValue = {
          Id: containerValue.SelectedValue?.Id,
          Name: fieldModel || "",
        };
        break;
      default:
        break;
    }
    return res_value;
  }
}
</script>
<style scoped>
ul {
  list-style: none;
  padding: 0;
  margin: 0;
  min-width: 150px;
  max-width: fit-content;
}

li {
  padding: 8px;
  cursor: pointer;
}

li:hover {
  background: #f0f0f0;
}

/* Контейнер подсказки: высота 100% fmenu, ширина по контенту — при переполнении скроллится вся .fmenu */
.parameter-inline-menu-row {
  height: 100%;
  max-height: 100%;
  width: max-content;
  min-width: 100%;
  overflow: visible;
  display: flex;
}

/* Строка с таблицей кастомных подсказок укладывается в меню: правый блок переносит
   содержимое вместо того, чтобы разгонять ширину и включать горизонтальный скролл */
.parameter-inline-menu-row--fit {
  width: 100%;
}

/* Только в этой подсказке при двух блоках без данных — контент не схлопывается; не больше 100%, чтобы влезало в fmenu */
.parameter-inline-menu-row--min-height-when-empty {
  min-height: min(360px, 100%);
}

.parameter-inline-menu-col {
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Заголовок столбца: высота 40px, контент по верху — левая кнопка и правая надпись выровнены */
.parameter-inline-menu-col__header {
  flex: 0 0 auto;
  height: 40px;
  min-height: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
}

/* Кнопка «Добавить/Удалить» слева: компактная по высоте, надпись по центру кнопки (перебиваем общую высоту заголовка) */
.parameter-inline-menu-col__header.parameter-inline-menu-col__header--btn {
  cursor: pointer;
  min-height: 28px !important;
  height: 28px !important;
  padding: 0 12px;
  margin: 8px 8px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25;
  transition: background-color 0.15s ease;
  box-sizing: border-box;
  max-width: calc(100% - 16px);
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
}

.parameter-inline-menu-col__header.parameter-inline-menu-col__header--btn.parameter-inline-menu-col__header--pending {
  opacity: 0.5;
  cursor: default;
}

.parameter-inline-menu-col__header.parameter-inline-menu-col__header--btn.parameter-inline-menu-col__header--pending:hover {
  background-color: transparent;
}

.parameter-inline-menu-col__header-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

/* Надпись «Позиции:» — некликабельная, отступ сверху чтобы совпала по вертикали с текстом кнопки, жирная */
.parameter-inline-menu-col__header--static {
  pointer-events: none;
  padding: 12px 0 0 8px;
  line-height: 1.25;
  font-size: 0.875rem;
  font-weight: bold;
}

/* Обёртка под aux-selector: забирает оставшуюся высоту, скролл только внутри селектора */
.parameter-inline-menu-col__selector {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* В левом блоке селектор явно ограничен по высоте: минус высота заголовка (40px), чтобы влезал в fmenu */
.parameter-inline-menu-col--left .parameter-inline-menu-col__selector {
  height: calc(100% - 40px);
  max-height: calc(100% - 40px);
  flex: 0 0 auto;
  overflow: hidden;
}

/* Когда слева нет кнопки (998) — обёртка на всю высоту, отступ снизу меньше */
.parameter-inline-menu-col--left-no-header .parameter-inline-menu-col__selector {
  height: 100%;
  max-height: 100%;
}

/* В правом блоке то же: минус высота надписи «Позиции:» (40px), оба столбца выровнены по высоте */
.parameter-inline-menu-col__selector--right {
  height: calc(100% - 40px);
  max-height: calc(100% - 40px);
  flex: 0 0 auto;
  overflow: hidden;
}

.parameter-inline-menu-col--right-hints .parameter-inline-menu-col__selector--right {
  height: 100%;
  max-height: 100%;
}

/* Левый блок: высота 100% строки; min/max ширина для выпадающего меню; скролл только внутри aux-selector */
.parameter-inline-menu-col--left {
  flex: 0 1 300px;
  min-width: 300px;
  max-width: min(33.333%, 320px);
  height: 100%;
  min-height: 0;
  word-wrap: break-word;
  white-space: normal;
}

/* Правый блок: ширина по контенту, при переполнении скроллится вся .fmenu */
.parameter-inline-menu-col--right {
  flex: 0 0 auto;
  width: min-content;
  min-width: 0;
}

/* Таблица кастомных подсказок вместо этого занимает остаток ширины меню */
.parameter-inline-menu-col--right-hints {
  flex: 1 1 auto;
  width: auto;
}

</style>

<style>
.parameter-inline-hint-anchor {
  position: fixed;
  height: 0;
  pointer-events: none;
}

.q-tooltip.parameter-inline-tooltip {
  z-index: 10010;
}
</style>
